module.exports = {
  // заглушка если текста нет
  ' ': ' ',
  DELETE_PARTICIPANT: 'प्रतिभागियों को हटाएं',
  'country.AZ': 'अज़रबैजान',
  'country.AM': 'आर्मेनिया',
  'country.BY': 'बेलारूस',
  'country.BE': 'बेल्जियम',
  'country.BG': 'बुल्गारिया',
  'country.GB': 'ग्रेट ब्रिटेन',
  'country.DE': 'जर्मनी',
  'country.IL': 'इज़राइल',
  'country.IN': 'भारत',
  'country.IT': 'इटली',
  'country.KZ': 'कज़ाखस्तान',
  'country.CY': 'साइप्रस',
  'country.KG': 'किर्गिज़स्तान',
  'country.KR': 'कोरिया',
  'country.LB': 'लेबनान',
  'country.LT': 'लिथुआनिया',
  'country.LV': 'लातविया',
  'country.RU': 'रूस',
  'country.RO': 'रोमानिया',
  'country.US': 'संयुक्त राज्य अमेरिका',
  'country.SA': 'सऊदी अरब',
  'country.TJ': 'ताजिकिस्तान',
  'country.TH': 'थाईलैंड',
  'country.TQ': 'तुर्की',
  'country.UZ': 'उज़्बेकिस्तान',
  'country.UA': 'यूक्रेन',
  'country.FR': 'फ्रांस',
  'country.CH': 'स्विट्ज़रलैंड',
  'country.SE': 'स्वीडन',
  'country.EE': 'एस्टोनिया',
  'country.CN': 'चीन',
  'country.TW': 'ताइवान',
  'country.CA': 'कनाडा',
  'country.MY': 'मलेशिया',
  'country.HK': 'हाँग काँग',
  'country.VN': 'वियतनाम',
  'country.PS': 'फिलिस्तीन',
  'country.EG': 'मिस्र',
  'country.JO': 'जॉर्डन',
  'country.IQ': 'इराक',
  'country.IR': 'ईरान',
  'country.AE': 'संयुक्त अरब अमीरात',
  'country.AU': 'ऑस्ट्रेलिया',
  'country.ZA': 'दक्षिण अफ्रीका',
  // start sign in
  'signin.title': 'लॉग इन',
  'signin.subtitle': 'अपना डेटा दर्ज करें',
  'signin.password_old': 'वर्तमान पासवर्ड',
  'signin.password_new': 'नया पासवर्ड',
  'signin.password_confirm': 'नए पासवर्ड की पुष्टि करें',
  'signin.btn_title': 'लॉग इन',
  'signin.repeat':
    'पंजीकरण की पुष्टि नहीं हुई है। ईमेल में दिए गए निर्देशों का पालन करें। पुष्टि ईमेल {repeat}',
  // end sign in
  // start sign up
  'signup.title': 'पंजीकरण',
  'signup.subtitle': 'विवरण दर्ज करें',
  'signup.btn_title': 'पंजीकरण करें',
  INVALID_TOKEN: 'अमान्य सत्यापन कोड।',
  VALIDATION_EMAIL_ALREADY_EXIST: 'यह ईमेल पता पहले से पंजीकृत है।',
  VALIDATION_EMAIL_ALREADY_USED: 'यह ईमेल पहले से उपयोग में है',
  'signup.success_message':
    'प्रदान किए गए पते पर एक पुष्टि ईमेल भेजा गया है। यदि आपको यह प्राप्त नहीं होता है, तो कृपया अपना विवरण फिर से दर्ज करने के लिए पंजीकरण पृष्ठ पर लौटें या तकनीकी सहायता से संपर्क करें।',
  // end sign up
  // start verify
  'verify.success_message': 'आपका पंजीकरण सफल रहा। लॉग इन करने के लिए, ',
  'verify.success_message_link': 'अपना लॉगिन और पासवर्ड दर्ज करें',
  // end verify
  // start resend
  'resend.success_message': 'ईमेल भेज दिया गया है',
  // end resend
  // start logout
  'logout.title': 'लॉग आउट',
  'logout.success_message': 'आप लॉग आउट हो चुके हैं',
  // end logout
  // start forgot-password
  'forgotPassword.title': 'पासवर्ड भूल गए?',
  'forgotPassword.subtitle': 'अपने खाते तक पहुँचने के लिए नया पासवर्ड बनाएं',
  'forgotPassword.btn_title': 'सबमिट करें',
  'forgotPassword.success_message':
    'आपके ईमेल पर पासवर्ड रीसेट लिंक भेजा गया है। यदि आपको यह प्राप्त नहीं होता है, तो कृपया पासवर्ड रीसेट पृष्ठ पर लौटकर पुनः प्रयास करें, या तकनीकी सहायता से संपर्क करें।',
  // end forgot-password
  // start reset-password
  'resetPassword.title': 'पासवर्ड रीसेट',
  'resetPassword.btn_title': 'पासवर्ड रीसेट करें',
  'resetPassword.success_message':
    'आपका पासवर्ड सफलतापूर्वक रीसेट कर दिया गया है।',
  // end reset-password
  // start page ChangePassword
  'changePassword.title': 'पासवर्ड बदलें',
  'changePassword.btn_title': 'बदलें',
  'changePassword.success_message':
    'पासवर्ड सफलतापूर्वक बदल दिया गया है। कृपया इसे याद रखें या लिख लें।',
  // end page ChangePassword
  // start page Home
  'home.title': 'यहाँ स्वागत संदेश और चित्र दिखाई देंगे',
  // end page Home
  // start page NotFound
  'notFound.title': 'त्रुटि 404',
  'notFound.subtitle': 'पृष्ठ नहीं मिला',
  // end page NotFound
  // start page Forms
  'form.email': 'ईमेल',
  'form.password': 'पासवर्ड',
  'form.password_old': 'वर्तमान पासवर्ड',
  'form.password_new': 'नया पासवर्ड',
  'form.confirm_password': 'पासवर्ड की पुष्टि करें',
  'form.agree': 'मैं सहमत हूँ ....',
  'form.code': 'सत्यापन कोड',
  'form.error_required': 'आवश्यक',
  'form.error_invalid_email': 'अमान्य ईमेल पता',
  'form.error_invalid_phone': 'अमान्य फ़ोन नंबर (11 अंक आवश्यक)',
  'form.error_password_min': 'कम से कम {min} वर्ण',
  'form.error_password_letters': 'इसमें अक्षर होने चाहिए',
  'form.error_password_num': 'इसमें अंक होने चाहिए',
  'form.error_password_match': 'पासवर्ड मेल नहीं खाते',
  // end page Forms
  // common word
  'common.repeat': 'पुनः प्रयास करें',
  'common.success_message': 'सफल',
  // end cpmmom word
  // SUCCES_USER_UPDATE: "Пользователь успешно "
  'notice.success': 'सफल',
  SAVED: 'सहेजा गया',
  // Validate
  MUST_BE_CONTAINS_LETTERS: 'पासवर्ड में कम से कम 1 लैटिन अक्षर होना चाहिए',
  MUST_BE_CONTAINS_NUMBER: 'पासवर्ड में अंक होने चाहिए',
  MUST_BE_7_CHARACTERS_OR_MORE: 'पासवर्ड 7 या अधिक वर्णों का होना चाहिए',
  MUST_BE_4_CHARACTERS_OR_MORE: 'पासवर्ड 4 या अधिक वर्णों का होना चाहिए',
  MUST_BE_NUMERIC: 'संख्या होनी चाहिए',
  MUST_BE_POSITIVE: 'राशि 0 से अधिक होनी चाहिए',
  REQUIRED: 'यह फ़ील्ड आवश्यक है',
  PASSWORD_DO_NOT_MATCH: 'पासवर्ड मेल नहीं खाते',
  INVALID_EMAIL_ADDRESS: 'अमान्य ईमेल पता',
  UNACCEPTABLE_SIGNS: 'अमान्य वर्ण या रिक्त स्थान',
  INVALID_DATE: 'दिनांक DD.MM.YYYY प्रारूप में होनी चाहिए',
  TIMETABLE_ERROR: 'कृपया कार्य समय-सारणी निर्धारित करें',
  // end Validate
  // Errors
  INVALID_LOGIN_DATA: 'गलत ईमेल या पासवर्ड',
  CANNOT_FOUND_USER_WITH_THIS_EMAIL: 'इस ईमेल वाला उपयोगकर्ता नहीं मिला',
  INVALID_OLD_PASSWORD: 'वर्तमान पासवर्ड गलत है',
  EMPTY_OR_VERY_SHORT_PASSWORD: 'पासवर्ड गायब है या बहुत छोटा है',
  // End errors
  // Stub
  simulators: 'प्रशिक्षण सिम्युलेटर',
  stub1: 'संदर्भ सामग्री', // ??
  reports: 'रिपोर्ट',
  // End Stub

  // Главный фильтр (Правило)
  RULE_SIMPLE_SUM: 'सीधी गिनती',
  RULE_FIVE_SUM: '5 के सूत्र',
  RULE_TEN_SUM: '10 का सूत्र',
  RULE_FIVE_AND_TEN_SUM: '5 और 10 के सूत्र',
  NO_MODE: 'यादृच्छिक',
  // Главный фильтр
  // Меню
  DIRECTORY: 'निर्देशिका',
  ARCHIVE: 'संग्रह',
  // Student
  // Table
  STUDENT_TITLE: 'छात्र',
  STUDENT_TITLE_SINGULAR: 'छात्र',
  STUDENT_FORM_LEFT_PATH_TITLE: 'छात्र का विवरण',
  STUDENT_FORM_RIGTH_PATH_TITLE: 'अभिभावक का विवरण',
  STUDENT_TABLE_CREATE_TITLE: 'नया छात्र जोड़ें',
  STUDENT_TABLE_SAVE_TITLE: 'छात्र की जानकारी संपादित करें',
  STUDENT_TABLE_CREATE: 'शिक्षक के बिना छात्र',
  STUDENT_TABLE_INVITE: 'निमंत्रण भेजें',
  STUDENT_TABLE_REGISTER: 'छात्र पंजीकृत करें',
  STUDENT_TABLE_SAVE: 'सहेजें',
  STUDENT_ADD: 'छात्र जोड़ें',
  STUDENT_SUCCESS_CREATE_MESSAGE: 'छात्र जोड़ा गया',
  STUDENT_SUCCESS_SAVE_MESSAGE: 'छात्र की जानकारी सफलतापूर्वक अपडेट की गई',
  // Group
  GROUP_TITLE: 'समूह',
  GROUP_TITLE_SINGULAR: 'समूह',
  GROUP_FORM_LEFT_PATH_TITLE: 'मूल फ़ील्ड',
  GROUP_FORM_RIGHT_PATH_TITLE: 'अतिरिक्त फ़ील्ड',
  GROUP_TABLE_CREATE_TITLE: 'नया समूह जोड़ें',
  GROUP_TABLE_SAVE_TITLE: 'समूह की जानकारी संपादित करें',
  GROUP_TABLE_CREATE: 'जोड़ें',
  GROUP_TABLE_SAVE: 'सहेजें',
  GROUP_SUCCESS_CREATE_MESSAGE: 'समूह जोड़ा गया',
  GROUP_SUCCESS_SAVE_MESSAGE: 'समूह सफलतापूर्वक अपडेट किया गया',
  // School
  // Table
  SCHOOL_TITLE: 'विद्यालय',
  SCHOOL_FORM_LEFT_PATH_TITLE: 'विद्यालय प्रशासक का विवरण',
  SCHOOL_FORM_RIGHT_PATH_TITLE: 'विद्यालय की जानकारी',
  SCHOOL_TABLE_CREATE_TITLE: 'नया विद्यालय जोड़ें',
  SCHOOL_TABLE_SAVE_TITLE: 'विद्यालय की जानकारी संपादित करें',
  SCHOOL_TABLE_CREATE: 'जोड़ें',
  SCHOOL_TABLE_SAVE: 'सहेजें',
  SCHOOL_SUCCESS_CREATE_MESSAGE: 'विद्यालय जोड़ा गया',
  SCHOOL_SUCCESS_SAVE_MESSAGE: 'विद्यालय की जानकारी सफलतापूर्वक अपडेट की गई',
  SCHOOL_INFO: 'विद्यालय की जानकारी',
  // Teacher
  // Table
  TEACHER_TITLE: 'शिक्षक',
  TEACHER_FORM_LEFT_PATH_TITLE: 'मूल फ़ील्ड',
  TEACHER_FORM_RIGHT_PATH_TITLE: 'अतिरिक्त फ़ील्ड',
  TEACHER_TABLE_CREATE_TITLE: 'नया शिक्षक जोड़ें',
  TEACHER_TABLE_SAVE_TITLE: 'शिक्षक की जानकारी संपादित करें',
  TEACHER_TABLE_CREATE: 'जोड़ें',
  TEACHER_TABLE_SAVE: 'सहेजें',
  TEACHER_SUCCESS_CREATE_MESSAGE: 'शिक्षक जोड़ा गया',
  TEACHER_SUCCESS_SAVE_MESSAGE: 'शिक्षक की जानकारी सफलतापूर्वक अपडेट की गई',
  // Homework
  // Table
  HOMEWORK_TITLE: 'गृहकार्य',
  HOMEWORK_TITLE_SETTINGS: 'गृहकार्य सेटिंग्स',
  HOMEWORK_TITLE_SINGULAR: 'गृहकार्य असाइनमेंट',
  HOMEWORK_FORM_LEFT_PATH_TITLE: 'पैरामीटर सेटिंग्स',
  HOMEWORK_FORM_RIGHT_PATH_TITLE: 'उपयोगकर्ता सेटिंग्स',
  HOMEWORK_TABLE_CREATE_TITLE: 'बनाएं',
  HOMEWORK_TABLE_SAVE_TITLE: 'संपादित करें',
  HOMEWORK_TABLE_CREATE: 'बनाएं',
  HOMEWORK_TABLE_SAVE: 'सहेजें',
  HOMEWORK_SUCCESS_CREATE_MESSAGE: 'गृहकार्य असाइनमेंट जोड़ा गया',
  HOMEWORK_SUCCESS_SAVE_MESSAGE:
    'गृहकार्य असाइनमेंट सफलतापूर्वक अपडेट किया गया',
  HOMEWORK_STARTED_CARRY_OUT: 'असाइनमेंट पर काम शुरू किया',
  LAST_WEEK_DATES:
    'ग्रेड किया गया गृहकार्य पूर्णता तिथि के आधार पर 7 दिनों की अवधि के लिए प्रदर्शित किया जाता है',
  // Table
  EXAMS_TITLE: 'परीक्षा',
  EXAMS_TITLE_SINGULAR: 'परीक्षा',
  EXAMS_FORM_LEFT_PATH_TITLE: 'परीक्षा पैरामीटर',
  EXAMS_FORM_RIGHT_PATH_TITLE: 'परीक्षा सांख्यिकी',
  EXAMS_TABLE_CREATE_TITLE: 'नई परीक्षा जोड़ें',
  EXAMS_TABLE_SAVE_TITLE: 'परीक्षा संपादित करें',
  EXAMS_TABLE_CREATE: 'बनाएं',
  EXAMS_TABLE_SAVE: 'सहेजें',
  EXAMS_SUCCESS_CREATE_MESSAGE: 'परीक्षा सफलतापूर्वक बनाई गई',
  EXAMS_SUCCESS_RESULT: 'परीक्षा परिणाम सफलतापूर्वक सहेजे गए',
  EXAMS_SUCCESS_SAVE_MESSAGE: 'परीक्षा डेटा सफलतापूर्वक अपडेट किया गया',
  EXAM_SUCCESS_SAVE: 'लिंक सफलतापूर्वक सहेजा गया',
  // Book
  // Table
  WORKBOOK_BUTTON: 'नमूने बनाएं',
  WORKBOOK_TITLE: 'प्रिंट करने योग्य नमूने',
  CERTIFICATION_TITLE: 'प्रमाणन',
  CERTIFICATION_SIMULATE_TITLE: 'सिमुलेशन',
  SIMULATE_PAUSE: 'प्रतियोगिता सिमुलेशन रुका हुआ है। कृपया प्रतीक्षा करें',
  CERTIFICATION_SIMULATE_SAMA_TITLE: 'SAMA GLOBAL सिमुलेशन',
  CERTIFICATION_SIMULATE_PAMA_TITLE: 'PAMA GLOBAL सिमुलेशन',
  CERTIFICATION_SIMULATE_UAMAP_TITLE: 'UAMAP सिमुलेशन',
  CERTIFICATION_EXAM_TITLE: 'परीक्षा',
  BOOK_TITLE: 'टीमवर्क',
  WORKBOOK_TO_PRINT: 'प्रिंटर पर भेजें',
  CAR_ICON: 'कार',
  PLANE_ICON: 'विमान',
  ELEPHANT_ICON: 'हाथी का बच्चा',
  HELICOPTER_ICON: 'हेलीकॉप्टर',
  TIGER_ICON: 'बाघ का बच्चा',
  FOX_ICON: 'लोमड़ी का बच्चा',
  FAWN_ICON: 'हिरण का बच्चा',
  CROCODILE_ICON: 'मगरमच्छ',
  SQUIRREL_ICON: 'गिलहरी का बच्चा',
  BEAR_ICON: 'टेडी बियर',
  WOLF_ICON: 'भेड़िया का बच्चा',
  LEOPARD_ICON: 'तेंदुआ',
  COLUMN: 'स्तंभ',
  SIMULATORS: 'प्रशिक्षक',
  EDIT_PROFILE: 'प्रोफ़ाइल संपादित करें',
  EXIT_INSIDE_PROFILE: 'बाहर निकलें',
  NAME: 'नाम',
  SURNAME: 'उपनाम',
  NAME_EN: 'नाम (अंग्रेज़ी)',
  SURNAME_EN: 'उपनाम (अंग्रेज़ी)',
  SEX: 'लिंग',
  MIDDLE_NAME: 'मध्य नाम',
  STATUS: 'स्थिति',
  TRANSACTION_STATUS: 'स्थिति',
  EXAM_LINK: 'Yandex लिंक',
  CITY: 'शहर',
  EMAIL: 'ईमेल पता',
  EMAIL_SHORT: 'ईमेल',
  PHOTO_LINK: 'प्रतिभागी फ़ोटो लिंक',
  MAIN_PAGE_ROOMA_TITLE: 'त्वरित पहुँच: अंज़ान',
  MAIN_PAGE_ROOMA_DESCRIPTION:
    'इस अनुभाग में आप अपने कौशल देख और सुधार सकते हैं',
  MAIN_PAGE_ROOMB_TITLE: 'त्वरित पहुँच: स्तंभ',
  MAIN_PAGE_ROOMB_DESCRIPTION:
    'इस अनुभाग में आप अपने कौशल देख और सुधार सकते हैं',
  MAIN_PAGE_ROOMC_TITLE: 'त्वरित पहुँच: फ्लैश कार्ड',
  MAIN_PAGE_ROOMC_DESCRIPTION:
    'इस अनुभाग में आप अपने कौशल देख और सुधार सकते हैं',
  DETAIL: 'अधिक विवरण...',
  SET_YOUR_DATE_OF_BIRTH: 'अपनी जन्म तिथि दर्ज करें',
  ROLE_GUEST: 'अनधिकृत',
  ROLE_STUDENT: 'छात्र',
  ROLE_TEACHER: 'शिक्षक',
  ROLE_SCHOOL: 'विद्यालय',
  ROLE_ADMIN: 'प्रशासक',
  ROLE: 'उपयोगकर्ता प्रकार',
  CABINET: 'डैशबोर्ड',
  SETTINGS: 'सेटिंग्स',
  BASIC_SETTINGS: 'मूल सेटिंग्स:',
  ADDITIONAL_SETTINGS: 'विस्तृत सेटिंग्स:',
  TRAINER_SETTINGS: 'प्रशिक्षक सेटिंग्स',
  room: 'कमरा',
  amount: 'नमूनों की संख्या',
  OLIMPIC_SAMPLES_TITLE: 'नमूने',
  section: 'अनुभाग',
  animation: 'एनिमेशन',
  windows: 'स्क्रीन की संख्या',
  simulator: 'प्रशिक्षक',
  steps: 'ऑपरेंड की संख्या',
  period: 'नमूनों के बीच विराम',
  INTERVAL: 'प्रदर्शन गति',
  interval: 'प्रदर्शन गति',
  ACTIVATE_NEGATIVE: 'ऋणात्मक संख्याएँ सक्षम करें',
  NEGATIVE_ANSWER: 'ऋणात्मक अंतिम उत्तर',
  mode: 'विषय',
  sign: 'चिह्न',
  bound: 'संक्रमण',
  under: 'से',
  over: 'तक',
  of: 'का',
  rule: 'नियम',
  numbers: 'अनुभाग',
  formulas: 'संख्या(ओं) के लिए सूत्र:',
  formulas_once: 'सूत्र:',
  student: 'छात्र',
  students: 'छात्र',
  individ: 'व्यक्तिगत रूप से',
  date: 'तिथि',
  dates: 'तिथियाँ',
  daily: 'दैनिक',
  daily_over: 'दैनिक तक',
  numbers_of_terms: 'ऑपरेंड की संख्या',
  numbers_in_example: 'नमूने में ऑपरेंड की संख्या',
  comment: 'टिप्पणी',
  first_int_available_numbers: 'पहला गुणक',
  second_int_available_numbers: 'दूसरा गुणक',
  order_first_int_available_numbers: 'पहले गुणक का स्थान मान',
  order_second_int_available_numbers: 'दूसरे गुणक का स्थान मान',
  DIVISION: 'भाग',
  MULTIPLICATION: 'गुणन',
  MULTIDIVISION: 'गुणन/भाग',
  divider: 'भाजक',
  dividend: 'भाज्य',
  // Animation Types
  FADING: 'फीका होना',
  SLIDE_UP: 'ऊपर स्लाइड',
  SLIDE_DOWN: 'नीचे स्लाइड',
  SLIDE_LEFT: 'बाएं स्लाइड',
  SLIDE_RIGHT: 'दाएं स्लाइड',
  BIGGER_FONT: 'बड़ा फ़ॉन्ट',
  SMALLER_FONT: 'छोटा फ़ॉन्ट',
  RANDOM_PLACE: 'यादृच्छिक स्थान',
  MULTICOLORED_NUMBERS: 'बहुरंगी संख्याएँ',
  NO_ANIMATIONS: 'कोई एनिमेशन नहीं',
  // Training Rooms
  roomA: 'अंज़ान',
  roomB: 'स्तंभ',
  roomC: 'फ्लैश कार्ड',
  roomD: 'शुल्टे टेबल',
  anzan_title: 'अंज़ान',
  columns_title: 'स्तंभ',
  cards_title: 'फ्लैश कार्ड',
  schulte_table_title: 'शुल्टे टेबल',
  // Math Parameters
  MINIMUM_RATE: 'न्यूनतम उत्तर स्थान मान',
  MAXIMUM_RATE: 'अधिकतम उत्तर स्थान मान',
  BOTH_ARE_SMALLER: 'दोनों छोटे',
  BOTH_ARE_BIGGER: 'दोनों बड़े',
  OPPOSITE_SIDES: 'विपरीत पक्ष',
  // Controls
  START: 'शुरू',
  STOP: 'रोकें',
  MIX: 'मिश्रण',
  CLOSE: 'बंद करें',
  CHECK: 'जांचें',
  ANSWER: 'उत्तर',
  ANSWERS: 'उत्तर',
  PROGRESS: 'लोड हो रहा है',
  ENTER_ANSWER: 'उत्तर दर्ज करें',
  // Reports
  REPORT_TITLE:
    'सांख्यिकी सभी अनुभागों में पूर्ण किए गए कार्यों को दिखाती है: गृहकार्य और दूरस्थ रूप से हल की गई समस्याएं।',
  REPORT_DESCRIPTION:
    'सही/गलत उत्तरों की संख्या बाईं ऊर्ध्वाधर स्केल पर दिखाई जाती है; माध्यिका मान पैरामीटर के लिए: अंतराल, ऑपरेंड की संख्या, संख्या स्थान मान दाईं ऊर्ध्वाधर स्केल पर चिह्नित किए गए हैं।',
  NUMBER_OF_TERMS: 'ऑपरेंड की संख्या',
  NUMBER_RANK: 'संख्या स्थान मान',
  digit: 'अंक स्थान मान',
  FILTER: 'फ़िल्टर',
  // Results
  SUCCESS: 'सही',
  FAIL: 'गलत',
  RATE: 'स्कोर',
  ADDRESS: 'पता',
  DESCRIPTION: 'विवरण',
  FULL_NAME: 'पूरा नाम',
  SUCCESS_ALL: 'सही/कुल',
  OPERATION: 'संचालन',
  TOTAL_TASKS: 'कुल कार्य',
  TASKS: 'कार्य',
  TOTAL_SUCCESS: 'सही उत्तर',
  // Homework
  REPORT_HOMEWORK:
    'संक्षिप्ताक्षर: (नियम), (अनुभाग), (सूत्र), (चिह्न), (समय अवधि), (ऑपरेंड की संख्या), (स्थान मान), (पहला गुणक), (दूसरा गुणक)',
  ADD_HOMEWORK: 'बनाएं',
  DELETE_HOMEWORK: 'गृहकार्य हटाएं',
  DELETE_SELECTED: 'चयनित हटाएं',
  SAVE_HOMEWORK: 'पूर्ण करें और सहेजें',
  WARNING_HOMEWORK: 'परिवर्तन सभी छात्रों को प्रभावित करेंगे!',
  WARNING_HOMEWORK_DELETE: 'गृहकार्य असाइनमेंट हटाएं?',
  WARNING_HOMEWORK_CHECK: 'गृहकार्य को जांचा गया चिह्नित करें?',
  WARNING_HOMEWORK_EDIT:
    'छात्र ने पहले से ही असाइनमेंट शुरू कर दिया है। परिणाम रीसेट हो जाएंगे',
  WARNING_HOMEWORK_CANT_EDIT: 'पूर्ण असाइनमेंट संपादित नहीं किया जा सकता!',
  WARNING_HOMEWORK_CANT_DELETE: 'पूर्ण असाइनमेंट हटाया नहीं जा सकता!',
  SHOW_SOLUTION: 'समाधान दिखाएं',
  MARK_COMPLETE: 'ग्रेड करें',
  GO_TO_HOMEWORK: 'असाइनमेंट पर जाएं',
  // Filter & Pagination
  FILTER_ALL: 'सभी रिकॉर्ड',
  FILTER_TITLE: 'फ़िल्टर',
  FILTER_RESET: 'फ़िल्टर रीसेट करें',
  PAGINATION_NEXT: 'अगला',
  PAGINATION_PREVIOUS: 'पिछला',
  PAGINATION_ROWS_PER_PAGE: 'प्रति पृष्ठ पंक्तियाँ:',
  PAGINATION_DISPLAY_ROWS: 'का',
  VIEW_COLUMN_TITLE: 'स्तंभ दिखाएं/छिपाएं',
  VIEW_COLUMN_TITLE_AREA: 'स्तंभ दिखाएं/छिपाएं',
  VIEW: 'दिखाएं',
  HIDE: 'छिपाएं',
  BODY_NO_MATCH: 'कोई मेल खाती रिकॉर्ड नहीं मिली',
  BODY_NO_TOOL_TIP: 'क्रमबद्ध करें',
  BODY_NO_COLUMN_HEADER_TOOLTIP: 'द्वारा क्रमबद्ध करें',
  SELECTED_ROWS_TEXT: 'रिकॉर्ड चयनित',
  SELECTED_ROWS_TEXT_HOMEWORKS: 'जांचा गया',
  SELECTED_ROWS_DELETE: 'हटाएं',
  SELECTED_ROWS_DELETE_ARIA: 'चयनित रिकॉर्ड हटाएं',
  FILTERING: 'फ़िल्टर करें',
  // Math Sections
  NEGATIVE_NUMBERS: 'ऋणात्मक संख्याएँ',
  SECTION_UP_TO_FOUR: '1-4 तक गिनती',
  SECTION_UP_TO_FIVE: '5 तक गिनती',
  SECTION_UP_TO_SIX: '6 तक गिनती',
  SECTION_UP_TO_SEVEN: '7 तक गिनती',
  SECTION_UP_TO_EIGHT: '8 तक गिनती',
  SECTION_UP_TO_NINE: '9 तक गिनती',
  SECTION_MIRROR: 'दर्पण संख्याएँ',
  SECTION_TEN: 'गोल संख्याएँ',
  // Division
  DIVISION_TABLE: 'भाग तालिका',
  DIVISION_REMAINDER: 'शेषफल के साथ भाग',
  DIVISION_SIMPLE: 'सरल भाग 4D/2D',
  DIVISION_ONE_ITERATE: '1 परीक्षण के साथ भाग 4D/2D',
  DIVISION_MORE_ITERATE: '2+ परीक्षणों के साथ भाग 4D/2D',
  DIVISION_SAME: 'समान अग्रणी अंकों के साथ भाग 4D/2D',
  DIVISION_BY_ONE: '1 से भाग 4D/2D',
  DIVISION_RANDOM: 'यादृच्छिक भाग',
  DIVISION_FIRST: 'भाज्य',
  DIVISION_SECOND: 'भाजक',
  // Multiplication
  MULTIPLICATION_TABLE: 'गुणन तालिका',
  MULTIPLICATION_SIMPLE: 'सरल गुणन',
  MULTIPLICATION_RANDOM: 'यादृच्छिक गुणन',
  MULTIPLICATION_ONE_ITERATE: '0 के साथ गुणन',
  MULTIPLICATION_MORE_ITERATE: '5 के साथ गुणन',
  MULTIPLICATION_FIRST: 'गुणक 1',
  MULTIPLICATION_SECOND: 'गुणक 2',
  MULTIPLIER: 'गुणक',
  // Advanced Math
  DECIMAL_MODE: 'दशमलव',
  SQRT: 'वर्गमूल',
  CURT: 'घनमूल',
  SQUARE: 'वर्ग संख्या',
  CUBE: 'घन संख्या',
  ANSWER_DISCHARGE: 'उत्तर स्थान मान',
  ANSWER_DISCHARGE_TYPE: 'उत्तर',
  RANDOM_TYPE: 'यादृच्छिक',
  SMALL_FISH: 'न्यूनतम उत्तर स्थान मान (छोटी मछली)',
  BIG_FISH: 'अधिकतम उत्तर स्थान मान (बड़ी मछली)',
  SMALL_MOUSE: 'न्यूनतम उत्तर स्थान मान (छोटा चूहा)',
  BIG_MOUSE: 'अधिकतम उत्तर स्थान मान (बड़ा चूहा)',
  // Rotation Types
  ROTATION_TYPE: 'घूर्णन',
  RANDOM_ROTATION: 'यादृच्छिक',
  SINGLE_ROTATION: 'एकल',
  DOUBLE_ROTATION: 'दोहरी',
  // Answers
  NUMERALS: 'अंक',
  RIGHT_ANSWERS: 'सही उत्तर',
  RIGHT_ANSWER: 'सही उत्तर ',
  WRONG_ANSWERS: 'गलत उत्तर',
  // Simulator Settings
  SIMULATOR_TYPE: 'प्रशिक्षक प्रकार',
  SIMULATOR_SETTINGS: 'प्रशिक्षक पैरामीटर',
  PARAMS: 'पैरामीटर',
  NUMBER_OF_WINDOWS: 'विंडो संख्या',
  NUMBER_OF_EXAMPLES: 'नमूना संख्या',
  count: 'नमूना संख्या',
  COMPLETION_TIME: 'समय',
  TIME_LIMIT_VALUE: 'समय सीमा (मिनट:सेकंड)',
  TIME_LIMIT_MODE: 'समय मोड',
  LIMITED_TIME: 'सीमित समय',
  UNLIMITED_TIME: 'असीमित समय',
  RESTART: 'पुनः प्रयास करें',
  // Division Components
  CEIL: 'पूर्णांक',
  REMAINDER: 'शेषफल',
  SECOND: 'सेकंड',
  TERMS: 'ऑपरेंड',
  // Base System
  base: 'आधार',
  base_side: 'आधार पक्ष',
  digits_mode: 'अंक स्थान मान मोड',
  DIGITS_MODE_MIN_RANGE: 'न्यूनतम उत्तर स्थान मान',
  DIGITS_MODE_MAX_RANGE: 'अधिकतम उत्तर स्थान मान',
  DIGITS_MODE_RANDOM_RANGE: 'यादृच्छिक',
  BASE_SIDE_LESS: 'दोनों आधार से कम',
  BASE_SIDE_MORE: 'दोनों आधार से अधिक',
  BASE_SIDE_DIFF: 'आधार के विपरीत पक्ष',
  // EXCEED
  NOT_EXCEED_50: 'बिना',
  NOT_EXCEED_100: '50 से अधिक',
  EXCEED_100: '100 से अधिक',
  // Dictation
  DICTATION_AMOUNT: 'नमूनों की संख्या',
  DICTATION_PERIOD: 'नमूनों के बीच विराम',
  DICTATION_START: 'श्रुतलेख शुरू करें',
  DICTATION_STOP: 'श्रुतलेख रोकें',
  DICTATION_NEXT: 'श्रुतलेख जारी रखें',
  // School Information
  SCHOOL_NAME: 'नाम',
  SCHOOL_CITY: 'शहर',
  SCHOOL_ADDRESS: 'पता',
  SCHOOL_METRO_STATION: 'मेट्रो स्टेशन',
  SCHOOL_FULL_NAME_OF_HEAD: 'निर्देशक का पूरा नाम',
  PHONE: 'फ़ोन',
  PREVIOUS_PAGE: 'पिछला पृष्ठ',
  NEXT_PAGE: 'अगला पृष्ठ',
  EDIT_DATA: 'डेटा संपादित करें',
  ADD_RECORD: 'रिकॉर्ड जोड़ें',
  DELETE_RECORD: 'रिकॉर्ड हटाएं',
  RESTORE_USER: 'उपयोगकर्ता पुनर्स्थापित करें',
  RECORD_PER_PAGE: 'प्रति पृष्ठ पंक्तियाँ',
  PASSWORD: 'पासवर्ड',
  DATE_REGISTRATED: 'पंजीकरण तिथि',
  DATE_BEGINING: 'प्रारंभ तिथि',
  DATE_ENDING: 'समाप्ति तिथि',
  DATE_CREATING: 'निर्माण तिथि',
  DATE_DELETED: 'हटाने की तिथि',
  BY_DAYS: 'दिनों के अनुसार',
  CREATED: 'बनाया गया',
  // UI Elements
  SELECTED: 'चुनें...',
  NOT_RECORD: 'कोई रिकॉर्ड नहीं',
  NOT_FOUND_CATEGORIES_FOR_OLIMPIC:
    'आपके जन्म वर्ष के लिए कोई श्रेणी नहीं मिली',
  DIRECTORY_STUDENTS_TITLE:
    'सभी छात्र जिन्होंने प्लेटफ़ॉर्म पर स्वतंत्र रूप से पंजीकरण किया, रेफरल लिंक के माध्यम से भी',
  ICON: 'आइकन',
  // User Interface
  user_guide: 'उपयोगकर्ता गाइड',
  user_online: 'ऑनलाइन: {count}',
  _users: 'उपयोगकर्ता',
  _online: 'ऑनलाइन',
  RESET: 'रीसेट करें',
  CHOOSE_THEME: 'थीम चयन',
  ABACUS_DESCRIPTION:
    'नए विषयों को समझाने के लिए वर्चुअल अबाकस और बोर्ड का उपयोग करें।',
  MARKS: 'अबाकस पर चिह्न कैसे लगाएं',
  ABACUS: 'अबाकस',
  DESK: 'बोर्ड',
  // Student Management
  GROUPS: 'समूह',
  EMAIL_STUDENT: 'छात्र ईमेल',
  NAME_SURNAME_STUDENT: 'छात्र का नाम और उपनाम',
  AGE: 'आयु',
  EMAIL_PARENT: 'अभिभावक ईमेल',
  NAME_SURNAME_PARENT: 'अभिभावक का नाम',
  ACTIVE: 'सक्रिय',
  SEND_EMAIL_TO_STUDENT: 'इस ईमेल पर लॉगिन क्रेडेंशियल भेजें',
  DATEBIRTH: 'जन्म तिथि',
  YES: 'हाँ',
  NO: 'नहीं',
  SEARCH: 'खोजें',
  SEARCH_STUDENTS: 'छात्र खोज',
  SEARCH_DATE: 'तिथि खोज',
  REPEAT_PASSWORD: 'पासवर्ड दोहराएं',
  I_AGREE: 'मैं गोपनीयता नीति और उपयोग की शर्तों से सहमत हूँ',
  // Certification
  WITH_ANSWER: 'उत्तर शामिल करें',
  WITH_ANSWER_SEPARATE_SHEET: 'उत्तर अलग पृष्ठ पर',
  TO_PRINT: 'प्रिंट करें',
  CERTIFICATION_PAGE_TITLE_SAMA:
    'SAMA GLOBAL ABACUS & MENTAL ARITHMETIC EXAMINATION',
  CERTIFICATION_PAGE_TITLE_PAMA:
    'PAMA GLOBAL ABACUS & MENTAL ARITHMETIC EXAMINATION',
  CERTIFICATION_PAGE_TITLE_UAMAP: 'UAMAP मानसिक गणित परीक्षा',
  CERTIFICATION_LEVEL_TIME: 'समय',
  MIN: 'मिनट',
  MENTAL_ARITHMETIC: 'मानसिक गणना',
  ARITHMETIC_FOR_CHILDREN: 'बच्चों के स्तर',
  ARITHMETIC_FOR_TEACHER: 'शिक्षक स्तर',
  FOR_CHILDREN: 'बच्चों के लिए',
  FOR_TEACHER: 'शिक्षकों के लिए',
  ABACUS_ARITHMETIC: 'अबाकस गणना',
  MENTAL_ARITHMETIC_ADD: 'मानसिक गणना (+,-)',
  ABACUS_ARITHMETIC_ADD: 'अबाकस गणना (+,-)',
  MENTAL_ARITHMETIC_MULTIPLICATION: 'मानसिक गणना ( )',
  ABACUS_ARITHMETIC_MULTIPLICATION: 'अबाकस गणना ( )',
  MENTAL_ARITHMETIC_DIVISION: 'मानसिक गणना (÷)',
  ABACUS_ARITHMETIC_DIVISION: 'अबाकस गणना (÷)',
  ADD: 'जोड़',
  CARD: 'संख्या छवि',
  FIVE: '5 की संरचना',
  TEN: '10 की संरचना',
  NEXT_LEVEL: 'अगला कार्य',
  NEXT_TEST: 'एक और परीक्षण हल करें',
  RESULT: 'परिणाम',
  SCORE: 'स्कोर',
  LEVEL: 'स्तर',
  LEVEL_1: 'स्तर 1',
  LEVEL_2: 'स्तर 2',
  LEVEL_3: 'स्तर 3',
  LEVEL_4: 'स्तर 4',
  LEVEL_5: 'स्तर 5',
  LEVEL_6: 'स्तर 6',
  LEVEL_7: 'स्तर 7',
  LEVEL_7_A: 'स्तर 7 A',
  LEVEL_7_B: 'स्तर 7 B',
  LEVEL_8: 'स्तर 8',
  LEVEL_8_A: 'स्तर 8 A',
  LEVEL_8_B: 'स्तर 8 B',
  LEVEL_9: 'स्तर 9',
  LEVEL_9_A: 'स्तर 9 A',
  LEVEL_9_B: 'स्तर 9 B',
  LEVEL_10: 'स्तर 10',
  LEVEL_10_A: 'स्तर 10 A',
  LEVEL_10_B: 'स्तर 10 B',
  LEVEL_11: 'स्तर 11',
  LEVEL_12: 'स्तर 12',
  LEVEL_13: 'स्तर 13',
  LINK_BY_VIDEO: 'डिस्क लिंक',
  SAVE_RESULT_BY_TEST: 'परीक्षा परिणाम सहेजें',
  STARTING_EXAM: 'परीक्षा शुरू करें',
  ABACUS_TYPE: 'अबाकस,',
  MENTAL_TYPE: 'मानसिक',
  ADD_TYPE: 'जोड़ और घटाव (+, -)',
  MULTIPLICATION_TYPE: 'गुणन ( )',
  MULTIPLICATION_TABLE_TYPE: 'गुणन तालिका ( )',
  MULTIDIVISION_TYPE: 'गुणन और भाग तालिका',
  MULTIDIV_TYPE: 'गुणन और भाग',
  DIVISION_TABLE_TYPE: 'भाग तालिका (÷)',
  DIVISION_TYPE: 'भाग (÷)',
  TIE_TYPE: 'टाई-ब्रेकर',
  PRINT_CERTIFICATION: 'प्रमाणपत्र प्रिंट करें',
  CREATE_CERTIFICATION: 'प्रमाणपत्र बनाएं',
  EXAM_CHECKING: 'परीक्षा समीक्षा के अधीन है',
  EXAM_STATUS_NOT_FOUND: 'परीक्षा स्थिति निर्धारित नहीं हुई',
  EXAM_WAITING_RUN:
    'परीक्षा बनाई गई और छात्र के खाते में पूर्ण होने की प्रतीक्षा कर रही है',
  SET_CODE: 'अपना कोड दर्ज करें',
  CHECK_CODE: 'सत्यापित करें',
  CERTIFICATION_NOT_FOUND:
    'इस कोड वाला प्रमाणपत्र नहीं मिला, कृपया पुनः प्रयास करें।',
  // Navigation
  SCHEDULE_TITLE: 'अनुसूची',
  PROFILE_TITLE: 'प्रोफ़ाइल',
  NEWS_TITLE: 'समाचार',
  NEWS_EDIT_TITLE: 'फ़ीड',
  NEWS_FEED_TITLE: 'प्रबंधन',
  DELEGATES: 'प्रतिनिधि',
  TEAM_MODE_TITLE: 'टीम मोड',
  OLIMPIC_TITLE: 'प्रतियोगिता',
  FOR_PARENTS_TITLE: 'अभिभावकों के लिए',
  // Actions
  REGISTER: 'पंजीकरण करें',
  // Homework Status
  HOMEWORK_STATUS: 'स्थिति',
  COMPLETED: 'पूर्ण',
  OVERCOMPLETE: 'अधिक पूर्ण',
  UNCOMPLETED: 'अपूर्ण',
  // General
  USER: 'उपयोगकर्ता',
  CERTIFICAT: 'प्रमाणपत्र',
  CATEGORY: 'श्रेणी',
  mark: 'अंक',
  // General
  COUNTRY: 'देश',
  EXAM_RESULT: 'परीक्षा परिणाम',
  GENERATE_XLSX: 'XLSX उत्पन्न करें',
  GENERATE_SAMA_XLSX: 'SAMA XLSX उत्पन्न करें',
  GENERATE_PAMA_XLSX: 'PAMA XLSX उत्पन्न करें',
  SAVE_TO_COMPUTER: 'कंप्यूटर पर सहेजें',
  CHANGE_RANKS: 'चयनित संशोधित करें',
  SET_OLIMPIC_RANKS: 'प्रतिभागियों को सौंपने के लिए रैंक चुनें',
  // Ranking System
  STARS: 'सितारे',
  STARS_FOR_HOMEWORK: 'गृहकार्य के लिए सितारे',
  RANK: 'रैंक',
  RANK_1: 'शुरुआती',
  RANK_2: 'जूनियर',
  RANK_3: 'बुककीपर',
  RANK_4: 'विशेषज्ञ',
  RANK_5: 'विद्वान',
  RANK_6: 'प्रतिभाशाली',
  RANK_7: 'सर्वज्ञ',
  RANK_8: 'अद्वितीय प्रतिभा',
  RANK_9: 'बाल प्रतिभाशाली',
  RANK_10: 'प्रतिभा',
  PLACE_IN_RATING: 'रेटिंग स्थान',
  NO_RATE: 'भाग नहीं ले रहा',
  FEATHERS: 'पंख',
  PROGRESS_TO_NEXT_RANK: 'अगली रैंक तक प्रगति',
  // Payments & Accounts
  SUMM: 'राशि',
  PURPOSE_OF_PAYMENT: 'भुगतान उद्देश्य',
  ENTER_PASSWORD: 'पासवर्ड दर्ज करें',
  CONFIRM_IS_PARENT:
    'आपके अभिभावक होने की पुष्टि करने के लिए, कृपया वर्तमान खाता पासवर्ड दर्ज करें',
  BALANCE: 'शेष राशि',
  UCOINS1: 'यूकॉइन',
  UCOINS2: 'यूकॉइन',
  UCOINS5: 'यूकॉइन',
  ACCESS_TO_PLATFORM: 'प्लेटफ़ॉर्म एक्सेस',
  INFINITY_ACCESS_TO_PLATFORM: 'असीमित प्लेटफ़ॉर्म एक्सेस',
  WAIT_PAY:
    'भुगतान लंबित है। ऑनलाइन चेकआउट पृष्ठ दूसरे ब्राउज़र टैब में खुला है',
  PAY: 'भुगतान करें',
  FREE: 'मुफ़्त',
  CERT_EXAM: 'प्रमाणपत्र परीक्षा',
  CERT_EXAMS: 'प्रमाणन परीक्षा',
  OLIMPIC_PARTICIPATION: 'प्रतियोगिता भागीदारी',
  OLIMPIC_PARTICIPATIONS: 'प्रतियोगिता भागीदारियाँ',
  CERT_SAMA_GLOBAL_EXAM: 'खरीदे गए SAMA GLOBAL परीक्षा',
  CERT_PAMA_GLOBAL_EXAM: 'खरीदे गए PAMA GLOBAL परीक्षा',
  CERT_UAMAP_EXAM: 'खरीदे गए UAMAP परीक्षा',
  OLIMPIC_ONLINE_PARTICIPATION: 'ऑनलाइन प्रतियोगिता भागीदारियाँ',
  OLIMPIC_OFFLINE_PARTICIPATION: 'ऑफलाइन प्रतियोगिता भागीदारियाँ',
  OLIMPIC_SAMA_PARTICIPATION: 'PAMA प्रतियोगिता भागीदारियाँ',
  REGISTER_STUDENTS: 'छात्र एक्सेस पैकेज',
  PURCHASED: 'खरीदा गया',
  DAYS_ON_PLATFORM: 'प्लेटफ़ॉर्म पर दिन',
  DAYS_LEFT: 'शेष दिन',
  SUSPENDED: 'निलंबित',
  UNTIL: 'तक',
  PROLONG: 'विस्तार करें',
  TOP_UP_ACCOUNT: 'खाता रिचार्ज करें',
  SAVE_CHANGES: 'परिवर्तन सहेजें',
  MOBILE_PHONE: 'मोबाइल फ़ोन',
  REFERALS_TITLE: 'रेफरल प्रणाली',
  MANAGEMENT: 'प्रबंधन',
  ABOUT_GAMIFICATION: 'गेमिफिकेशन के बारे में',
  UCOINS_TITLE: 'यूकॉइन',
  STATISTICS: 'सांख्यिकी',
  THEMATIC: 'थीम',
  CONTENT: 'सामग्री',
  BACK: 'वापस',

  // Errors & Messages
  ERROR_INCORRECT: 'आपने जो पासवर्ड दर्ज किया है वह गलत है',
  DEADLINE_ERROR: 'दैनिक असाइनमेंट की समय सीमा निर्धारित करें (अधिकतम 1 माह)',
  CONFIRM_PAYMENT: 'चयनित सेवा के लिए आपके शेष राशि से धनराशि काटी जाएगी',
  PAYMENT_LIMIT_WARNING:
    'अंतर्राष्ट्रीय उपयोगकर्ताओं के लिए केवल MIR और BELKART कार्ड स्वीकार किए जाते हैं',
  PURCHASE_ERROR: 'एक त्रुटि हुई',
  PURCHASE_NOT_ENOUGH: 'अपर्याप्त धनराशि',
  PURCHASE_SUCCESS: 'खरीदारी सफलतापूर्वक पूरी हुई',
  NOT_ENOUGH_PACK: 'पैकेज में पर्याप्त एक्सेस नहीं हैं',
  HAVE_ONLINE_OLIMPIC:
    'उपयोगकर्ता के पास पहले से ही ऑनलाइन प्रतियोगिता एक्सेस है',
  HAVE_OFFLINE_OLIMPIC:
    'उपयोगकर्ता के पास पहले से ही ऑफलाइन प्रतियोगिता एक्सेस है',
  HAVE_MAINTAINERS:
    'उपयोगकर्ता के पास पहले से ही ऑफलाइन प्रतियोगिता के लिए साथी टिकट है',
  NOT_REGISTERED_OFFLINE_OLIMPIC:
    'आपने ऑफलाइन प्रतियोगिता के लिए पंजीकरण नहीं किया है',
  REGISTER_STUDENT_ISUFFICIENT_FUNDS:
    'छात्रों को स्वतंत्र रूप से पंजीकृत करने के लिए, स्टोर में उपयुक्त एक्सेस पैकेज खरीदें',
  ACCESS_ISUFFICIENT_FUNDS:
    'प्लेटफ़ॉर्म एक्सेस की समय सीमा समाप्त हो गई है। अभिभावक/प्रबंधन अनुभाग में इसे नवीनीकृत करें',
  ACCESS_NO_DEMO_FUNDS: 'अभिभावक/प्रबंधन अनुभाग में प्लेटफ़ॉर्म एक्सेस खरीदें',
  ACCESS_ISUFFICIENT_FUNDS_TEACHER:
    'आपके पास कम से कम 1 भुगतान किया गया एक्सेस वाला छात्र होना चाहिए। आप इसके लिए स्वयं भुगतान कर सकते हैं',
  ACCESS_NO_DEMO_FUNDS_TEACHER:
    'आपके पास कम से कम 1 भुगतान किया गया एक्सेस वाला छात्र होना चाहिए। आप इसके लिए स्वयं भुगतान कर सकते हैं',
  SAMA_ACCESS_MESSAGE:
    'दुर्भाग्य से, आप अभी प्रतियोगिता में भाग नहीं ले सकते। कृपया अनुभाग में SAMA GLOBAL प्रतियोगिता एक्सेस खरीदें',
  PAMA_ACCESS_MESSAGE:
    'दुर्भाग्य से, आप अभी प्रतियोगिता में भाग नहीं ले सकते। कृपया अनुभाग में PAMA GLOBAL प्रतियोगिता एक्सेस खरीदें',
  NO_ACCESS: 'यह अनुभाग अनुपलब्ध है',
  ACCESS_NO_OLIMPIC: 'प्रतियोगिता में भागीदारी के लिए भुगतान आवश्यक है',
  // Products
  PRODUCTS_TITLE: 'मूल्य निर्धारण',
  PRODUCTS_LEARNER: 'छात्र उत्पाद',
  PRODUCTS_TEACHER: 'शिक्षक और विद्यालय उत्पाद',
  PRODUCTS_SCHOOL: 'विद्यालय उत्पाद',
  PRODUCTS_TEACHER_ASSOC: 'संघ प्रतिनिधि, शिक्षक उत्पाद',
  PRODUCTS_SCHOOL_ASSOC: 'संघ प्रतिनिधि, विद्यालय उत्पाद',
  PRODUCTS_ASSOC: 'संघ प्रतिनिधि उत्पाद',
  CONFIRM_PAY_PRODUCT:
    '"{product}" को {price} यूकॉइन में खरीदने की पुष्टि करें?',
  CONFIRM_PRODUCT: '{name} के लिए {price} यूकॉइन काटे जाएंगे।',
  CONFIRM_PRODUCT_SELF: '{price} यूकॉइन काटे जाएंगे।',
  CONFIRM_PAYMENT_PACKAGE:
    'छात्र {name} के लिए खरीदे गए एक्सेस पैकेज से भुगतान की पुष्टि करें?',
  CONFIRM_BUY_PACK: '{name} के लिए एक्सेस पैकेज की खरीद की पुष्टि करें?',
  CONFIRM_PACK:
    '{count} छात्रों के लिए एक्सेस पैकेज {price} यूकॉइन में खरीदा जाएगा',
  PACKAGES_AMOUNT: 'एक्सेस पैकेज',
  // UI Elements
  OK: 'ठीक है',
  CONFIRM: 'पुष्टि करें',
  CONTINUE: 'जारी रखें',
  CANCEL: 'रद्द करें',
  REFUSE: 'अस्वीकार करें',
  PURCHASES: 'खरीदारियाँ',
  currency: 'यूकॉइन',
  currency_short: 'यू.',
  CURRENCY_EQUAL: '1 रूबल = 1 यूकॉइन',
  ENTER_AMOUNT: 'रिचार्ज राशि दर्ज करें',
  NOT_SELECTED: 'चयनित नहीं',
  // Mental Arithmetic
  MENTAL_ARITHMETIC_TITLE: 'मानसिक गणित',
  ROOM_SHORT: 'कक्ष',
  TIME: 'समय',
  min: 'मिनट',
  EACH_Q: 'सही उत्तर',
  marks: 'अंक',
  DATE: 'तिथि',
  DATE_FORMAT: 'DD.MM.YYYY',
  SAVE: 'सहेजें',
  SAVE_LINK: 'लिंक सहेजें',
  link: 'लिंक',
  ADD_LESSON: 'पाठ जोड़ें',
  // Referral
  RECEIVE_BONUSES:
    'नए छात्रों या शिक्षकों को आमंत्रित करने पर बोनस अर्जित करें',
  REFERAL_LINK_FOR_STUDENTS: 'छात्रों के लिए रेफरल लिंक',
  REFERAL_LINK_FOR_TEACHERS: 'शिक्षकों के लिए रेफरल लिंक',
  COPY: 'कॉपी करें',
  ABOUT_REFERAL_ADMIN: 'रेफरल प्रणाली के बारे में',
  // Achievements
  ACHIEVEMENTS: 'उपलब्धियाँ',
  NEW: 'नया',
  NEW_OR_COMPLETED: 'नया / पूर्ण',
  TODAY_OR_ALL: 'आज / सभी',
  ALL_ACHIEVEMENTS: 'सभी उपलब्धियाँ',
  HERE_ALL_ACHIEVEMENTS:
    'यहाँ आप सभी उपलब्धियाँ देख सकते हैं, चाहे अर्जित हों या नहीं।',
  CLEAR: 'समझ गया',
  // Assignments
  WORKS: 'कार्य',
  HOME_WORKS: 'गृहकार्य',
  ALL_HOME_WORKS: 'सभी असाइनमेंट',
  HOME_WORKS_EMPTY: 'कोई गृहकार्य नहीं',
  ADD_TRAIN: 'यहाँ प्रशिक्षक जोड़ें',
  COMPLETE: 'पूर्ण करें',
  COMPLETE_OVER: 'तक पूर्ण करें',
  // Experience System
  FOR_RECEIVE_NEW_ACHIEVEMENTS:
    'नई उपलब्धियाँ अर्जित करने के लिए अनुभव प्राप्त करें',
  EXPERIENCE_GRADING: 'अनुभव ग्रेडिंग',
  EXPERIENCE_REQUIRED: 'आवश्यक अनुभव',
  // Feathers System
  CONFIRM_RESET_FEATHERS:
    'क्या आप वाकई सभी उपयोगकर्ताओं के पंख रीसेट करना चाहते हैं?',
  FOR_RESET_FEATHERS: 'सभी उपयोगकर्ताओं के पंख रीसेट करने के लिए क्लिक करें',
  RESET_FEATHERS: 'पंख रीसेट करें',
  CHAMPIONS_CORNER: 'चैंपियंस हॉल',
  PHOTO: 'फ़ोटो',
  OPEN_ALL_OLIMP_CHAMPIONS: 'सभी प्रतियोगिताएँ दिखाएं',
  // Ratings
  RATING: 'रेटिंग',
  TEACHER_RATING: 'शिक्षक रैंकिंग',
  STUDENT_RATING: 'छात्र रैंकिंग',
  PLACE: 'स्थान',
  place1: 'प्रथम स्थान',
  place2: 'द्वितीय स्थान',
  place3: 'तृतीय स्थान',
  PLACE_EN: 'स्थान',
  PLACE_LABEL: 'रैंक (संख्या, चैंपियन के लिए 0)',
  OPEN_FULL_LIST: 'पूरी सूची देखें',
  USERS_LIST: 'उपयोगकर्ता सूची',
  YOUR_PLACE_IN_RATING: 'आपकी वर्तमान रैंक',
  FOR_UP_IN_RATING_TEACHER:
    'ऊपर जाने के लिए: उपलब्धियाँ अर्जित करें, पाठ आयोजित करें, और नए छात्रों और शिक्षकों को आमंत्रित करें',
  FOR_UP_IN_RATING_STUDENT:
    'ऊपर जाने के लिए: अधिक नमूने हल करें और उपलब्धियों से पंख अर्जित करें',
  // User Information
  STUDENT_NAME: 'छात्र का नाम',
  TEACHER_NAME: 'शिक्षक का नाम',
  POINTS: 'अंक',
  TEACHER_ADD_STUDENT:
    'ने आपके बच्चे को अपनी छात्र सूची में जोड़ा है। कार्रवाई की पुष्टि करें?',
  // Subscriptions
  SUBSCRIBE_1_MONTH: '1 माह की सदस्यता',
  FROM_PACKET: 'पैकेज से',
  SUBSCRIBE_1_MONTH_PACKET: 'पैकेज से 1 माह की सदस्यता',
  SUBSCRIBE_6_MONTH: '6 माह की सदस्यता',
  SUBSCRIBE_12_MONTH: '1 वर्ष की सदस्यता',
  // Certifications
  SAMA_CERT: 'SAMA GLOBAL प्रमाणन',
  PAMA_CERT: 'PAMA GLOBAL प्रमाणन',
  UAMAP_CERT: 'UAMAP छात्र प्रमाणन',
  UAMAP_CERT_TEACHER: 'UAMAP शिक्षक प्रमाणन',
  SAMA_CERT_SHORT: 'SAMA GLOBAL',
  PAMA_CERT_SHORT: 'PAMA GLOBAL',
  UAMAP_CERT_SHORT: 'UAMAP छात्र',
  UAMAP_CERT_TEACHER_SHORT: 'UAMAP शिक्षक',
  // Time Periods
  MONTH: 'महीना',
  MONTHS: 'महीने',
  STUDENT_GENITIVE: 'छात्र का',
  STUDENTS_GENITIVE: 'छात्रों का',
  // Selection
  SELECT: 'चुनें',
  SELECT_PRODUCT: 'उत्पाद चुनें',
  SELECT_USER: 'उपयोगकर्ता चुनें',
  SELECT_LEARNER: 'छात्र चुनें',
  SELECT_STUDENT: 'छात्र चुनें',
  SELECT_TEACHER: 'शिक्षक चुनें',
  SELECT_STUDENTS_AMOUNT: 'प्रतिभागियों की संख्या चुनें',
  // Ucoins & Transactions
  ACCESS: 'प्लेटफ़ॉर्म एक्सेस खरीद',
  REPLENISHMENT: 'रिचार्ज',
  PACKET: 'एक्सेस पैकेज खरीद',
  ACCESS_FROM_PACKET: 'पैकेज से प्लेटफ़ॉर्म एक्सेस खरीद',
  SAMA_PAYMENT: 'SAMA GLOBAL प्रमाणन परीक्षा खरीद',
  PAMA_PAYMENT: 'PAMA GLOBAL प्रमाणन परीक्षा खरीद',
  UAMAP_PAYMENT: 'UAMAP प्रमाणन परीक्षा खरीद',
  ONLINE_OLIMPIC_PAYMENT: 'ऑनलाइन प्रतियोगिता भागीदारी खरीद',
  OFFLINE_OLIMPIC_PAYMENT: 'ऑफलाइन प्रतियोगिता भागीदारी खरीद',
  SAMA_OLIMPIC_PAYMENT: 'SAMA GLOBAL प्रतियोगिता भागीदारी खरीद',
  PAMA_OLIMPIC_PAYMENT: 'PAMA GLOBAL प्रतियोगिता भागीदारी खरीद',
  MAINTAINER_PAYMENT: 'प्रतियोगिता साथी',
  // Gamification Explanations
  GAMIFICATION_1:
    'गेमिफिकेशन गैर-खेल संदर्भों में खेल यांत्रिकी का अनुप्रयोग है। यह गेमिफिकेशन प्रणाली उपयोगकर्ता की भागीदारी और रुचि बढ़ाने का लक्ष्य रखती है। रैंकिंग शिक्षक और उनके छात्रों की उपलब्धियों पर आधारित है। परीक्षाएँ, रेफर किए गए छात्र, और पाठों की संख्या आपकी रैंकिंग में सुधार करती हैं।',
  GAMIFICATION_2:
    'शिक्षक विशिष्ट प्लेटफ़ॉर्म कार्यों को पूरा करके उपलब्धियाँ अर्जित कर सकते हैं।',
  GAMIFICATION_3:
    'गेमिफिकेशन खेलों के बारे में है। यहाँ आप खेल सकते हैं और विकसित हो सकते हैं। यह टैब प्लेटफ़ॉर्म पर सभी खेल यांत्रिकी की व्याख्या करता है। पंख अंक हैं जो छात्र रैंकिंग बनाते हैं। रैंकिंग सभी छात्रों की सूची है जो उनकी उपलब्धियों पर आधारित है। उपाधियाँ वे स्तर हैं जिनसे आप उपलब्धियाँ अर्जित करके आगे बढ़ते हैं। उपलब्धियाँ विशिष्ट कार्यों को पूरा करने के लिए पुरस्कार हैं।',
  GAMIFICATION_4: 'अब अधिक विस्तार से देखें',
  GAMIFICATION_5:
    'रैंकिंग हर 3 महीने में अपडेट होती है, जिससे शीर्ष छात्र और शिक्षक मूल्यवान पुरस्कार जीत सकते हैं।',
  GAMIFICATION_6:
    'रैंकिंग अर्जित पंखों (छात्रों के लिए) और रेटिंग अंकों (शिक्षकों के लिए) पर आधारित है। अधिक अंक = उच्च रैंक। शीर्ष-रैंक वाले उपयोगकर्ताओं को भौतिक और वर्चुअल पुरस्कार मिलते हैं।',
  GAMIFICATION_7: 'उपलब्धियाँ शिक्षक रैंकिंग में योगदान करती हैं।',
  GAMIFICATION_8:
    'अधिकतम उपलब्धियाँ और रेटिंग अंक प्राप्त करने के लिए: परीक्षाएँ दें, पाठ आयोजित करें, और प्लेटफ़ॉर्म के साथ सक्रिय रहें।',
  GAMIFICATION_9:
    'साथ ही अपने छात्रों को मेंटल गणित में पूरी तरह से डूबने के लिए प्रेरित करें।',
  GAMIFICATION_10: 'इसे याद रखें, और आप रैंकिंग के शीर्ष पर पहुँचेंगे!',
  GAMIFICATION_11:
    'उपलब्धियाँ प्लेटफ़ॉर्म गतिविधियों के माध्यम से अर्जित किए गए मज़ेदार बैज हैं। प्रत्येक अनुभव अंक और पंख देता है।',
  GAMIFICATION_12:
    'उपलब्धियाँ अर्जित होने पर रंगीन हो जाती हैं (वर्तमान में ग्रेस्केल)। आप संभावित पुरस्कारों का पूर्वावलोकन कर सकते हैं।',
  GAMIFICATION_13:
    'रेटिंग अंक मुख्य प्लेटफ़ॉर्म क्रियाओं और उपलब्धियों के माध्यम से अर्जित किए जाते हैं।',
  GAMIFICATION_14:
    'क्रियाओं में पाठ पढ़ाना, गृहकार्य देना, और उपयोगकर्ता रेफरल शामिल हैं।',
  GAMIFICATION_15:
    'पंख छात्र रैंकिंग अंक हैं जो उपलब्धियों और समस्या-समाधान (कठिन समस्याएँ = अधिक पंख) के माध्यम से अर्जित किए जाते हैं। नए विजेताओं को निर्धारित करने के लिए हर 3 महीने में रीसेट होता है।',
  GAMIFICATION_16:
    'उपाधियाँ पूर्ण किए गए कार्यों और उपलब्धियों के माध्यम से आपकी प्रगति का प्रतिनिधित्व करती हैं। अधिक अनुभव = बेहतर उपाधियाँ।',
  GAMIFICATION_17:
    'प्रत्येक स्तर एक नई उपाधि और अद्वितीय प्रोफ़ाइल अवतार फ़्रेम प्रदान करता है। "प्रतिभा" (स्तर 10) सबसे उच्च है।',
  GAMIFICATION_18:
    'अफवाह है कि सभी तक नहीं पहुँचते... यदि पहुँचते हैं, तो प्लेटफ़ॉर्म को खेल की तरह "पूर्ण" मानें।',
  GAMIFICATION_19: 'तारे पूर्ण किए गए गृहकार्य के लिए शिक्षक मूल्यांकन हैं।',
  GAMIFICATION_20:
    'बेहतर प्रयास = अधिक तारे। अपने शिक्षक के सर्वश्रेष्ठ छात्र बनें!',
  // Referral System
  REFERAL_ADMIN: 'रेफरल प्रणाली',
  MOVE_UCOINS_TO_BALANCE: 'यूकॉइन को शेष राशि में स्थानांतरित करें',
  INVITED_STUDENTS: 'रेफर किए गए छात्र',
  ACTIVE_STUDENTS: 'प्लेटफ़ॉर्म एक्सेस वाले सक्रिय छात्र',
  INVITED_TEACHERS: 'रेफर किए गए शिक्षक',
  EARNED_UCOINS: 'अर्जित यूकॉइन',
  REFERAL_TEXT_1: 'रेफरल प्रणाली आपको मुफ़्त में यूकॉइन अर्जित करने देती है।',
  REFERAL_TEXT_2:
    'अपने लिंक के माध्यम से नए छात्रों को पंजीकरण और सदस्यता के लिए भुगतान कराएं।',
  REFERAL_TEXT_3: 'आपको प्रति छात्र 25 यूकॉइन मिलेंगे।',
  REFERAL_TEXT_4:
    'अपने लिंक के माध्यम से छात्रों और शिक्षकों को रेफर करके मुफ़्त यूकॉइन अर्जित करें।',
  REFERAL_TEXT_4_S:
    'जब छात्र/शिक्षक आपके या आपके शिक्षकों के लिंक के माध्यम से पंजीकरण करते हैं तो मुफ़्त यूकॉइन अर्जित करें।',
  REFERAL_TEXT_5:
    'जब रेफर किए गए छात्र पहली बार प्लेटफ़ॉर्म एक्सेस के लिए भुगतान करते हैं तो 25 यूकॉइन प्राप्त करें।',
  REFERAL_TEXT_5_S:
    'जब आपके/आपके शिक्षकों द्वारा रेफर किए गए छात्र पहली बार भुगतान करते हैं तो 25 यूकॉइन प्राप्त करें।',
  REFERAL_TEXT_6:
    'जब आपके द्वारा रेफर किए गए शिक्षकों के छात्र भुगतान करते हैं तो 50 यूकॉइन प्राप्त करें।',
  REFERAL_TEXT_6_S:
    'जब आपके/आपके शिक्षकों द्वारा रेफर किए गए शिक्षकों के भुगतान करने वाले छात्र होते हैं तो 50 यूकॉइन प्राप्त करें।',
  REFERAL_TEXT_7: 'रेफर किए गए छात्रों के रिचार्ज राशि का 5% अर्जित करें।',
  REFERAL_TEXT_7_S:
    'आपके/आपके शिक्षकों द्वारा रेफर किए गए छात्रों के रिचार्ज का 2% अर्जित करें।',
  // Olympiad
  PERSONAL_RATING: 'व्यक्तिगत रैंकिंग',
  PUBLIC_RATING: 'समग्र रैंकिंग',
  RATING_UPDATE: 'रैंकिंग हर दिन 00:00 (मास्को समय) पर अपडेट होती है',
  SCORES_TITLE: 'रेटिंग अंक',
  RESULTS: 'परिणाम',
  RESULTS_NOTICE:
    'वीडियो की कमी या पिछले विजेताओं के उसी श्रेणी में बिना उन्नति के प्रतिस्पर्धा करने के कारण रैंक गिर सकती है',
  PARTICIPATE: 'भाग लें',
  PARTICIPATE_OFFLINE: 'ऑफलाइन प्रतियोगिता में भाग लें',
  OFFLINE_OLIMPIC_PARTICIPATE_NOTICE:
    'अब, सभी फ़ील्ड भरें और प्रतियोगिता के लिए पंजीकरण करने के लिए "भाग लें" पर क्लिक करें',
  OLIMPIC_REGLAMENT_NOTICE: 'कृपया प्रतियोगिता के नियमों को ध्यान से देखें!',
  GET_READY: 'तैयार हो जाओ!',
  CURRENT_PING: 'वर्तमान कनेक्शन गुणवत्ता',
  SEC: 'सेकंड',
  GOOD: 'अच्छा',
  NORMAL: 'सामान्य',
  WORST: 'खराब',
  DISCONNECTED: 'डिस्कनेक्ट',
  OLIMPIC_TYPE: 'प्रतियोगिता प्रकार',
  olimpic_files: 'फ़ाइलें अपलोड करें और आवश्यक लिंक डालें',
  OLIMPIC_LINK_REQUIRED_NOTIFY:
    'वीडियो लिंक आवश्यक है, अन्यथा पुरस्कार स्थान नीचे कर दिया जाएगा! सुनिश्चित करें कि वीडियो तक पहुँच खुली है। आप परिणामों की जाँच से पहले प्रतियोगिता के बाद भी लिंक जोड़ सकते हैं',
  OLIMPIC_START_NOTIFY:
    'हम आपको शुभकामनाएँ और जीत की कामना करते हैं! "प्रतियोगिता शुरू करें" बटन पर क्लिक करने के बाद, आप वापस नहीं जा सकेंगे, आपके पास केवल 1 प्रयास होगा। पूरी प्रतियोगिता को शुरू से अंत तक फ़िल्माया जाना चाहिए। वीडियो को किसी भी क्लाउड स्टोरेज पर अपलोड करें और लिंक जोड़ें।',
  OLIMPIC_PRE_RUN_NOTIFY:
    'अपनी तत्परता की पुष्टि करें और तैयारी टाइमर के समाप्त होने की प्रतीक्षा करें',
  IVE_READ_RULES: 'मैंने ध्यान से पढ़ा है और उपरोक्त नियमों से सहमत हूँ',
  PREPARED_CAMERA:
    'मैं वीडियो कैमरे पर प्रतियोगिता की प्रक्रिया को फ़िल्माने के लिए तैयार हूँ, और मैं सत्यापन के लिए वीडियो प्रदान करने के लिए सहमत हूँ',
  OLIMPIC_TECHNICAL_REQUIREMENT:
    'इंटरनेट कनेक्शन की गुणवत्ता जाँचें। टैब नेविगेशन, पृष्ठ पुनरारंभ और रिफ्रेश निषिद्ध हैं, और आपकी भागीदारी पूरी हो जाएगी!',
  IM_READY:
    'मैं प्रतियोगिता शुरू करने के लिए तैयार हूँ। मुझे कोई कनेक्शन समस्या नहीं है और मैं प्रतियोगिता का परिणाम सहेजे जाने तक पृष्ठ नहीं छोड़ूँगा।',
  ABOUT_OLIMPIC: 'प्रतियोगिता',
  SAMA_OLIMPIC: 'Sama Global',
  PAMA_OLIMPIC: 'Pama Global',
  PAY_OFFLINE_SELF: 'अपने लिए टिकट खरीदें',
  PAY_OTHER_OFFLINE: 'दूसरों के लिए टिकट खरीदें',
  OFFLINE_OLIMPIC: 'ऑफलाइन',
  OFFLINE_OLIMPIC_FOR_STUDENT: 'छात्र के लिए ऑफलाइन',
  OFFLINE_OLIMPIC_FOR_TEACHER: 'शिक्षक के लिए ऑफलाइन',
  ONLINE: 'ऑनलाइन',
  ONLINE_LEARNER: 'छात्र के लिए ऑनलाइन',
  ONLINE_TEACHER: 'शिक्षक के लिए ऑनलाइन',
  OLIMPIC_REQUIRE_PAYMENT: 'प्रतियोगिता भागीदारी भुगतान आवश्यक',
  ACCESS_REQUIRE_PAYMENT: 'प्लेटफ़ॉर्म एक्सेस भुगतान आवश्यक',
  REQUIRE_FIELDS: 'सभी फ़ील्ड भरे जाने चाहिए',
  OLIMPIC_LIST: 'प्रतियोगिता सूची',
  OLIMPIC_NOT_FOUND: 'कोई आगामी प्रतियोगिता नहीं मिली',
  WILL_PASS: 'आयोजित होगा',
  CREATE: 'जोड़ें',
  OLIMPIC_TABLE_CREATE_TITLE: 'प्रतियोगिता बनाएं',
  OLIMPIC_TABLE_EDIT_TITLE: 'प्रतियोगिता संपादित करें',
  OLIMPIC_TABLE_EDIT_PARTICIPANT: 'प्रतियोगिता प्रतिभागी संपादित करें',
  OLIMPIC_SUCCESS_CREATE_MESSAGE: 'प्रतियोगिता सफलतापूर्वक बनाई गई',
  OLIMPIC_SUCCESS_EDIT_MESSAGE: 'प्रतियोगिता सफलतापूर्वक अपडेट की गई',
  OLIMPIC_PRINT_TITLE: 'कार्य प्रिंट करें',
  TIME_BEGINING: 'प्रारंभ समय',
  TIME_ENDING: 'समाप्ति समय',
  OLIMPIC_SIMULATOR: 'प्रतियोगिता सिम्युलेटर',
  OLIMPIC_REGLAMENT: 'नियम',
  OLIMPIC_GROUPS_TASKS: 'समूह कार्य',
  OLIMPIC_START_VIDEO_LINK: 'प्रतियोगिता पूर्व वीडियो लिंक',
  OLIMPIC_END_VIDEO_LINK: 'प्रतियोगिता बाद वीडियो लिंक',
  OLIMPIC_DIPLOMA_LINK_RU: 'डिप्लोमा टेम्पलेट लिंक (रूसी)',
  OLIMPIC_DIPLOMA_LINK_EN: 'डिप्लोमा टेम्पलेट लिंक (अंग्रेज़ी)',
  OLIMPIC_GRATITUDE_LINK_RU: 'प्रशंसापत्र टेम्पलेट (रूसी)',
  OLIMPIC_GRATITUDE_LINK_EN: 'प्रशंसापत्र टेम्पलेट (अंग्रेज़ी)',
  CUP_IMAGE_LINK: 'कप छवि URL (चैंपियंस हॉल)',
  OLIMPIC_SYLLABUS: 'पाठ्यक्रम',
  OLIMPIC_RUN: 'प्रतियोगिता शुरू करें',
  SHOW_OFFLINE: 'ऑफलाइन के लिए दिखाएं',
  SHOW_ONLINE: 'ऑनलाइन के लिए दिखाएं',
  SHOW_SAMA: 'PAMA के लिए दिखाएं',
  RESET_OLIMPIC_PAYMENTS: 'प्रतियोगिता भुगतान रीसेट करें',
  RESET_FOR_ONLINE: 'ऑनलाइन के लिए रीसेट करें',
  RESET_FOR_OFFLINE: 'ऑफलाइन के लिए रीसेट करें',
  RESET_FOR_SAMA: 'PAMA के लिए रीसेट करें',
  CONFIRM_RESET_ALL_OLIMPIC_PAYMENTS:
    'सभी प्रतियोगिता भुगतान रीसेट करने की पुष्टि करें?',
  OLIMPIC_PAY_PARTICIPATE: 'प्रतियोगिता भागीदारी के लिए भुगतान करें',
  OLIMPIC_PAY: 'भागीदारी भुगतान करें',
  OFFLINE_OLIMPIC_PAY_PARTICIPATE: 'ऑफलाइन प्रतियोगिता के लिए भुगतान करें',
  SAMA_OLIMPIC_PAY_PARTICIPATE: 'SAMA प्रतियोगिता के लिए भुगतान करें',
  PAMA_OLIMPIC_PAY_PARTICIPATE: 'PAMA प्रतियोगिता के लिए भुगतान करें',
  OLIMPIC_REGISTERED: 'आपने प्रतियोगिता के लिए पंजीकरण किया है',
  OLIMPIC_STARTS: 'यह आयोजित होगा',
  FROM: 'से',
  TO: 'तक',
  OLIMPIC_COMPLETED: 'प्रतियोगिता पहले से ही पूर्ण हो चुकी है',
  DIPLOMS: 'डिप्लोमा',
  DIPLOMA: 'डिप्लोमा',
  DIPLOM_FOR_CENTER: 'केंद्र डिप्लोमा',
  DIPLOM_FOR_TEACHER: 'शिक्षक डिप्लोमा',
  CHANGE_TEXT: 'पाठ संपादित करें',
  ENTER_TEXT: 'पाठ दर्ज करें',
  YEARS: 'वर्ष',
  PAYMENT_PARAM_VALIDATION: 'उत्पाद चयन आवश्यक',
  PAYMENT_PARAMS_VALIDATION: 'उत्पाद और छात्र चयन आवश्यक',
  EXAM_REQUIRE_PAYMENT: 'परीक्षा भुगतान आवश्यक',
  OVERALL_SCORE: 'कुल स्कोर',
  SCORE_O: 'स्कोर',
  SCORE_MAX: 'अधिकतम स्कोर',
  STAGE: 'चरण',
  stage_num: 'चरण {stage}',
  OLIMPIC_PRINT_CLOSED_FOR_TEACHER:
    'प्रतियोगिता कार्य प्रिंट करने के लिए कम से कम एक भुगतान किया गया छात्र आवश्यक',
  OLIMPIC_PRINT_CLOSED_FOR_STUDENT:
    'प्रतियोगिता कार्य प्रिंट करने के लिए प्लेटफ़ॉर्म एक्सेस भुगतान आवश्यक',
  PARTICIPANTS: 'प्रतिभागी',
  OFFLINE_OLIMPIC_PARTICIPANTS: 'ऑफलाइन प्रतियोगिता प्रतिभागी',
  PARTICIPANT_OVZ: 'विकलांगता वाला प्रतिभागी',
  REQUIRED_OVZ_DOCUMENT:
    'कृपया टेलीग्राम के माध्यम से विकलांगता प्रमाणपत्र (संघ नियमों के अनुरूप) जमा करें',
  OVZ: 'विकलांगता',
  ASSOCIATION: 'संघ',
  export: 'निर्यात',
  MAINTAINER: 'साथी',
  TSHORT: 'टी-शर्ट',
  TSHIRT_SIZE: 'टी-शर्ट आकार',
  MAINTAINERS_COUNT: 'साथियों की संख्या',
  MAINTAINERS_LIMIT_FOR_1_PARTICIPANT: 'प्रति प्रतिभागी साथी टिकट सीमा',
  OLIMPIC_PARTICIPANT_SUCCESS_EDIT_MESSAGE:
    'प्रतियोगिता प्रतिभागी अपडेट किया गया',
  OLIMPIC_PARTICIPANTS_SUCCESS_EDIT_MESSAGE:
    'प्रतियोगिता प्रतिभागी अपडेट किए गए',
  PARTICIPANT_NOT_FOUND: 'प्रतिभागी नहीं मिला',
  PAID: 'भुगतान किया गया',
  PAID_6_MONTHS: '6-माह भुगतान आवश्यक',
  REQUIRED_6_MONTHS_OLIMPIC:
    'प्रतियोगिता केवल सक्रिय उपयोगकर्ताओं के लिए उपलब्ध है। आपके पास पिछले 6 महीनों के लिए प्लेटफ़ॉर्म एक्सेस का भुगतान होना चाहिए। आप अगले 6 महीनों के लिए एक्सेस खरीद सकते हैं। कृपया प्रतियोगिता नियमों की समीक्षा करें।',
  PAID_9_MONTHS: '9-माह भुगतान आवश्यक',
  REQUIRED_9_MONTHS_OLIMPIC:
    'प्रतियोगिता केवल सक्रिय उपयोगकर्ताओं के लिए उपलब्ध है। आपके पास पिछले 9 महीनों के लिए प्लेटफ़ॉर्म एक्सेस का भुगतान होना चाहिए। आप अब "1-वर्ष सदस्यता" अवधि के लिए एक्सेस खरीद सकते हैं। कृपया प्रतियोगिता नियमों की समीक्षा करें।',
  CONFIRM_DELETE_USER:
    'चेतावनी! क्या आप वाकई इस उपयोगकर्ता को हटाना चाहते हैं? इसे वापस नहीं किया जा सकता!',
  CONFIRM_DELETE_USERS:
    'चेतावनी! क्या आप वाकई {count} उपयोगकर्ताओं को हटाना चाहते हैं? इसे वापस नहीं किया जा सकता!',
  CONFIRM_ALIVE_USER:
    'क्या आप वाकई इस उपयोगकर्ता को पुनर्स्थापित करना चाहते हैं?',
  DELETED_USERS_TITLE: 'हटाए गए उपयोगकर्ता',
  CONFIRM_DELETE_OLIMPIC: 'क्या आप वाकई इस प्रतियोगिता को हटाना चाहते हैं?',
  CONFIRM_CLEAR_RESULT:
    'क्या आप वाकई प्रतिभागी के परिणाम रीसेट करना चाहते हैं?',
  CONFIRM_DELETE_OFFLINE_PARTICIPANT:
    'क्या आप वाकई प्रतिभागी का टिकट और उनके साथियों को हटाना चाहते हैं?',
  CONFIRM_DELETE_ONLINE_PARTICIPANT:
    'क्या आप वाकई प्रतिभागी को हटाना चाहते हैं?',
  OLIMPIC_ENCOURAGE:
    'हम आपको शुभकामनाएँ और जीत की कामना करते हैं! "प्रतियोगिता शुरू करें" बटन पर क्लिक करने के बाद, आप वापस नहीं जा सकेंगे, आपके पास केवल 1 प्रयास होगा। पूरी प्रतियोगिता को शुरू से अंत तक फ़िल्माया जाना चाहिए। वीडियो को किसी भी क्लाउड स्टोरेज पर अपलोड करें और लिंक जोड़ें।',
  OLIMPIC_LINK_WARN:
    'वीडियो लिंक आवश्यक है, अन्यथा पुरस्कार स्थान नीचे कर दिया जाएगा! सुनिश्चित करें कि वीडियो तक पहुँच खुली है। परिणामों की जाँच से पहले प्रतियोगिता के बाद भी लिंक जोड़ें',
  LINK_NOTICE:
    'लिंक बाद में प्रतियोगिता टैब पर जोड़ा जा सकता है। कृपया ध्यान दें बिना वीडियो के, परिणाम नहीं गिना जाएगा।',
  OLIMPIC_CONGRATS: 'बधाई, आपका प्रयास पूर्ण हुआ',
  END: 'समाप्त करें',
  BOLD: 'बोल्ड',
  custom_text: 'पाठ',
  CHAMPION: 'चैंपियन',
  CHAMPION_EN: 'चैंपियन',
  COMPETITOR_EN: 'प्रतिस्पर्धी',
  COMPETITOR: 'प्रतिस्पर्धी',
  // Math Categories
  AddMENTAL: 'मानसिक जोड़/घटाव',
  AddABACUS: 'अबाकस जोड़/घटाव',
  Card: 'संख्या दृश्यांकन',
  MultiABACUS: 'अबाकस गुणन',
  DivisionABACUS: 'अबाकस भाग',
  Multi: 'गुणन तालिका',
  Division: 'भाग तालिका',
  MultiMENTAL: 'मानसिक गुणन',
  DivisionMENTAL: 'मानसिक भाग',
  MultiDivision: 'गुणन/भाग तालिका',
  AddMENTALen: 'मानसिक जोड़ और घटाव',
  AddABACUSen: 'अबाकस पर जोड़ और घटाव',
  Carden: 'फ्लैश कार्ड',
  MultiABACUSen: 'अबाकस पर गुणन',
  DivisionABACUSen: 'अबाकस पर भाग',
  Multien: 'गुणन तालिका',
  Divisionen: 'भाग तालिका',
  MultiMENTALen: 'मानसिक गुणन',
  DivisionMENTALen: 'मानसिक भाग',
  MultiDivisionen: 'गुणन और भाग तालिका',
  // Competition Management
  OPEN_TICKET_SALES: 'टिकट बिक्री खोलें',
  SHOW_RESULTS: 'परिणाम दिखाएं',
  SHOW_DIPLOMS: 'डिप्लोमा दिखाएं',
  ACTIVE_SIMULATION: 'सिमुलेशन सक्षम करें',
  SHOW_RATING: 'रैंकिंग दिखाएं',
  SHOW_PRINT: 'कार्य प्रिंट सक्षम करें',
  ACTIONS: 'क्रियाएँ',
  ACTION: 'क्रिया',
  DIPLOM_EN: 'डिप्लोमा (अंग्रेज़ी)',
  DIPLOM_RU: 'डिप्लोमा (रूसी)',
  AFTER: 'बाद',
  DICTANT_SETTINGS: 'श्रुतलेख सेटिंग्स',
  OLIMPIC_SUCCESS_RESULT: 'प्रतियोगिता परिणाम सफलतापूर्वक सहेजे गए',
  PHONE_INVALID: 'अमान्य या गुम फ़ोन नंबर।',
  // Exam Statuses
  EXAM_NEW: 'परीक्षा बनाई गई',
  EXAM_FINISHED: 'परीक्षा पूर्ण',
  EXAM_IN_PROCESS: 'परीक्षा प्रगति पर',
  EXAM_ARCHIVE: 'परीक्षा संग्रहीत',
  EXAM_SUCCESSFUL: 'परीक्षा सफलतापूर्वक उत्तीर्ण',
  EXAM_SUCCESSFUL_RUN:
    'आपने परीक्षा उत्तीर्ण की, अपने प्रमाणपत्र की प्रतीक्षा करें',
  EXAM_FAILURE: 'परीक्षा अनुत्तीर्ण',
  EXAM_FAILURE_RUN: 'आपने परीक्षा उत्तीर्ण नहीं की, अभ्यास जारी रखें',
  EXAM_NOT_REQUIRED_NUMBER_OF_POINTS:
    'उपयोगकर्ता आवश्यक अंक प्राप्त नहीं कर सका (>=70 प्रति कार्य)',
  EXAM_TEACHER_DNOT_RUN_CERTIFICATION_FOR_SAMA:
    'शिक्षक SAMA प्रमाणपत्र जारी नहीं कर सकते - केवल व्यवस्थापक',
  EXAM_TEACHER_DNOT_RUN_CERTIFICATION_FOR_PAMA:
    'शिक्षक PAMA प्रमाणपत्र जारी नहीं कर सकते - केवल व्यवस्थापक',
  EXAM_TEACHER_DNOT_RUN_CERTIFICATION:
    'शिक्षक प्रमाणपत्र जारी नहीं कर सकते - केवल व्यवस्थापक',
  // Homework Statuses
  new: 'नया',
  process: 'प्रगति पर',
  success: 'पूर्ण',
  overfill: 'अधिक पूर्ण',
  left_tasks: 'शेष',
  // Motivational Phrases
  HIT_1: 'अपने शिक्षक को प्रभावित करें!',
  HIT_2: 'सबको चकित करें!',
  HIT_3: 'इसे अगले स्तर पर ले जाएं!',
  HIT_4: 'क्या आप और बेहतर कर सकते हैं?',
  // Training Modes
  FLASH_CARD: 'फ्लैश कार्ड',
  FLASH_BATTLE: 'फ्लैश-बैटल',
  ANZAN: 'अंज़ान',
  ANZAN_VIRTUAL: 'वर्चुअल अंज़ान',
  SOUND: 'ध्वनि',
  AUTOREPEAT: 'स्वत: दोहराव',
  DICTANT: 'श्रुतलेख',
  SHOW_ANSWERS: 'श्रुतलेख उत्तर',
  SHOW_EXAMPLES: 'नमूने दिखाएं',
  HIDE_EXAMPLES: 'नमूने छिपाएं',
  SHOW_ANSWER: 'उत्तर दिखाएं',
  HIDE_ANSWER: 'उत्तर छिपाएं',
  EXAMPLE: 'नमूना',
  max_discharge: 'अधिकतम उत्तर स्थान मान (बड़ी मछली)',
  min_discharge: 'न्यूनतम उत्तर स्थान मान (छोटी मछली)',
  ABACUS_FULL: 'पूर्ण अबाकस दिखाएं',
  ABACUS_ALIGN: 'अबाकस केंद्र से गणना करें',
  // Modals
  UPDATE_MODAL_TITLE: 'प्रिय उपयोगकर्ता!',
  UPDATE_MODAL_MESSAGE:
    'हमने अपने प्लेटफ़ॉर्म को अपडेट किया है! समस्याएँ ठीक की गईं और नई सुविधाएँ जोड़ी गईं। उन्हें उपयोग करना शुरू करने के लिए पृष्ठ ताज़ा करें!',
  UPDATE: 'अपडेट करें',
  SKIP: 'बाद में',
  // Progress Messages
  EXAMPLE_EXECUTED_CONGRATS: 'बधाई, यह कार्य पूर्ण हुआ!',
  TIME_OVERWRITE_WARNING:
    'कृपया ध्यान दें: शुल्टे प्रशिक्षक में, प्रत्येक नया परिणाम पिछले को ओवरराइट करता है, भले ही पूर्णता समय बढ़ गया हो।',
  GO_NEXT_EXAMPLES: 'अन्य कार्यों पर जाएं',
  GO_LINK: 'जाएं',
  CONTINUE_EXAMPLE: 'यह कार्य जारी रखें',
  // Teamwork
  TEAMWORK_USERS_INVITE_TITLE: 'ऑनलाइन छात्रों को आमंत्रित करें!',
  TEAMWORK_INVITE_TITLE: '{user} आपको सत्र में आमंत्रित करता है!',
  INVITE_ACTION: 'आमंत्रित करें',
  INVITED: 'आमंत्रित',
  ACCEPT: 'स्वीकार करें',
  DECLINE: 'अस्वीकार करें',
  TEAMWORK_KICK_TITLE: 'क्या आप वाकई {user} को सत्र से हटाना चाहते हैं?',
  'teamwork.user.joined': 'छात्र जुड़ा',
  'teamwork.user.left': 'छात्र ने प्रशिक्षक छोड़ दिया',
  // Painter
  CLEAR_DRAWING: 'साफ़ करें',
  SIZE: 'आकार',
  COLOR: 'रंग',
  PIXELS_SHORT: 'पिक्सेल',
  // Referral Clues
  S_REFERRAL_CLUE:
    'अपना लिंक साझा करें! जब मित्र पंजीकरण और एक्सेस के लिए भुगतान करते हैं, तो आपको 25 यूकॉइन मिलेंगे',
  T_TO_S_REFERRAL_CLUE_1:
    'अपने छात्रों और अन्य के साथ साझा करें! जब वे पंजीकरण और भुगतान करते हैं, तो आपको 25 यूकॉइन मिलेंगे!',
  T_TO_S_REFERRAL_CLUE_2: 'नोट: ',
  T_TO_S_REFERRAL_CLUE_3:
    'आपको अभी भी अपने छात्रों को निर्देशिका/छात्र/सूची से जोड़ना होगा',
  T_TO_T_REFERRAL_CLUE:
    'अन्य शिक्षकों को रेफर करें! जब वे पंजीकरण और भुगतान करने वाले छात्रों को जोड़ते हैं, तो आपको 50 यूकॉइन मिलेंगे!',
  // System Clues
  RATING_CLUE: 'रैंकिंग हर दिन 00:00 (मास्को समय) पर अपडेट होती है',
  S_ACCESS_CLUE: 'भुगतान के तुरंत बाद पूर्ण प्लेटफ़ॉर्म एक्सेस शुरू होता है',
  S_CERT_EXAM_CLUE:
    'प्रमाणपत्र भुगतान के बाद, परीक्षा निर्धारित करने के लिए अपने शिक्षक/व्यवस्थापक को सूचित करें',
  OLIMPIC_PARTICIPATION_CLUE:
    'प्रतियोगिताओं के लिए अलग भुगतान आवश्यक है। सिमुलेशन और ऑनलाइन भागीदारी केवल सक्रिय प्लेटफ़ॉर्म एक्सेस के साथ उपलब्ध है',
  // Balance Clues
  BALANCE_CLUE_1: 'सभी मूल्य यूकॉइन में (1 यूकॉइन = 1 रूबल)। ',
  BALANCE_CLUE_2:
    "खरीदने के लिए, 'खाता रिचार्ज करें' के माध्यम से अपना शेष राशि रिचार्ज करें। ",
  BALANCE_CLUE_3:
    'भुगतान की गई सुविधाएँ सक्रिय करने के लिए खरीदारियाँ पूरी करना न भूलें!',
  // Teacher Access Clues
  T_ACCESS_CLUE_1: 'यहाँ छात्र एक्सेस खरीदें। ',
  T_ACCESS_CLUE_2:
    'भुगतान की गई अवधि के लिए भुगतान की गई सुविधाएँ तुरंत खुलती हैं। ',
  T_ACCESS_CLUE_3: 'से भुगतान करने के लिए ',
  T_ACCESS_CLUE_4: 'पूर्व-खरीदे गए एक्सेस पैकेज ',
  T_ACCESS_CLUE_5: "केवल 'पैकेज से 1 माह' चुनें!",
  // Certification Clues
  T_CERT_EXAM_CLUE:
    "छात्र भुगतान के बाद, 'प्रमाणन/परीक्षा' के अंतर्गत उनकी परीक्षा बनाएं या व्यवस्थापक से संपर्क करें। शिक्षक केवल प्रशिक्षण के बाद UAMAP परीक्षा दे सकते हैं",
  CERT_EXAM_CLUE_2: "'परीक्षा' टैब के लिए सक्रिय प्लेटफ़ॉर्म एक्सेस आवश्यक है",
  // Package Clues
  ACCESS_PACKET_CLUE_1:
    'छात्रों के लिए रियायती मासिक एक्सेस (प्रति छात्र दर)। ',
  ACCESS_PACKET_CLUE_2:
    'पैकेज में असीमित संग्रहण है और वे जुड़ते हैं। किसी भी समय छात्र एक्सेस का विस्तार करें। ',
  ACCESS_PACKET_CLUE_3:
    "प्लेटफ़ॉर्म एक्सेस 'पैकेज से 1 माह (शेष: ...)' के अंतर्गत शेष राशि जांचें",
  // Homework Clues
  NEW_HOMEWORK_CLUE_1:
    'यहाँ केवल वर्तमान सक्रिय गृहकार्य सेटिंग्स दिखाई गई हैं। समय सीमा समाप्त असाइनमेंट स्वचालित रूप से गायब हो जाते हैं। ',
  NEW_HOMEWORK_CLUE_2: 'अति-असाइनमेंट से बचने के लिए कार्यों को संपादित करें। ',
  NEW_HOMEWORK_CLUE_3:
    "पूर्ण गृहकार्य 'समीक्षा के लिए' के अंतर्गत दिखाई देता है",
  CREATE_HOMEWORK_CLUE:
    'नोट: गृहकार्य केवल तभी पूर्ण माना जाता है जब सभी प्रशिक्षक आवश्यक नमूना संख्या तक पहुँचते हैं। ',
  DAILY_HOMEWORK_CLUE:
    "'दैनिक' सेटिंग हर दिन नया गृहकार्य बनाती है। अपूर्ण दैनिक कार्य ('पूर्ण' स्थिति के बिना) सहेजा नहीं जाता है। हम सकारात्मक प्रेरणा को बढ़ावा देते हैं - कोई ऋण ट्रैकिंग नहीं। ",
  DAILY_MAX_HOMEWORK_CLUE:
    'वर्तमान सीमा: {count} दैनिक असाइनमेंट। अधिक छात्र = उच्च सीमा',
  DEADLINE_HOMEWORK_CLUE:
    "दीर्घकालिक पूर्णता लक्ष्यों के लिए, 'तक पूर्ण करें' सेटिंग का उपयोग करें",
  // Homework Completion
  COMPLETED_HOMEWORK_CLUE_1:
    "गृहकार्य को 'पूर्ण' या 'अधिक पूर्ण' स्थिति के साथ पूर्ण चिह्नित किया जाता है।",
  COMPLETED_HOMEWORK_CLUE_2:
    'पूर्णता के अगले दिन यहाँ दिखाई देता है। छात्र 24 घंटों के भीतर आवश्यकताओं से अधिक कर सकते हैं। समीक्षा करते समय पूर्ण/अधिक पूर्ण काउंटरों पर ध्यान दें।',
  COMPLETED_HOMEWORK_CLUE_3:
    'तारे और टिप्पणियों का उपयोग करके गृहकार्य का मूल्यांकन करें',
  // Exam Requirements
  EXAM_CLUE:
    'परीक्षा प्रयास रिकॉर्ड किया जाना चाहिए (वीडियो आवश्यक)। रिकॉर्डिंग का लिंक संलग्न करें।',
  EXAM_CLUE_2:
    'वीडियो को क्लाउड स्टोरेज (Google Drive, Yandex Disk, आदि) पर अपलोड करें और लिंक साझा करें।',
  // Abacus Interaction
  ABACUS_CLUE:
    'मार्क करने के लिए अबाकस बीम पर क्लिक करें। मार्क हटाने के लिए फिर से क्लिक करें।',
  // Competition Management
  CREATE_PARTICIPANT: 'नया प्रतिभागी बनाएं',
  EDIT_PARTICIPANT: 'प्रतिभागी संपादित करें',
  SELECT_COUNTRY: 'देश चुनें',
  SELECT_CATEGORY: 'श्रेणी चुनें',
  OLIMPIC_CHOOSE_CATEGORY:
    'यदि आपने पहले पुरस्कार जीता है तो श्रेणी को सख्ती से ऊपर चुनें। नियमों का पालन न करने पर अयोग्यता हो सकती है',
  DELEGATE: 'प्रतिनिधि',
  CREATE_DELEGATE: 'नया प्रतिनिधि बनाएं',
  EDIT_DELEGATE: 'प्रतिनिधि संपादित करें',
  SET_PLACE: 'स्थान निर्धारित करें',
  CLEAR_RESULT: 'परिणाम साफ़ करें',
  // Information Sections
  REGULATIONS: 'नियम',
  INFORMATION: 'जानकारी',
  DIPLOMAS: 'डिप्लोमा',
  MENTAL: 'मानसिक',
  SELECT_PLACE: 'स्थान चुनें',
  // Technical
  SOUND_CLUE: 'आपके ब्राउज़र में ध्वनि संश्लेषण समर्थित नहीं है',
  // Data Table
  'table.no-match': 'क्षमा करें, कोई मेल खाती रिकॉर्ड नहीं मिली',
  'table.tooltip': 'क्रमबद्ध करें',
  'table.next': 'अगला पृष्ठ',
  'table.previous': 'पिछला पृष्ठ',
  'table.rows_per_page': 'प्रति पृष्ठ पंक्तियाँ:',
  'table.display_rows': 'का',
  'table.jump_to_page': 'पृष्ठ पर जाएं:',
  'table.search': 'खोजें',
  'table.download_csv': 'डाउनलोड करें',
  'table.print': 'प्रिंट करें',
  'table.view_columns': 'स्तंभ देखें',
  'table.filter_table': 'फ़िल्टर',
  'table.all': 'सभी',
  'table.filter_title': 'फ़िल्टर',
  'table.reset': 'रीसेट करें',
  'table.title': 'दृश्यमान स्तंभ',
  'table.title_aria': 'स्तंभ दिखाएं/छिपाएं',
  'table.text': 'चयनित',
  'table.delete': 'हटाएं',
  'table.delete_aria': 'चयनित पंक्तियाँ हटाएं',
  // Products
  'product.type_1.1': 'प्लेटफ़ॉर्म एक्सेस (1 माह)',
  'product.type_1.6': 'प्लेटफ़ॉर्म एक्सेस (6 माह)',
  'product.type_1.12': 'प्लेटफ़ॉर्म एक्सेस (12 माह)',
  'product.type_2.10': 'एक्सेस पैकेज (10 छात्र)',
  'product.type_2.25': 'एक्सेस पैकेज (25 छात्र)',
  'product.type_2.50': 'एक्सेस पैकेज (50 छात्र)',
  'product.type_3.1': 'पैकेज से एक्सेस',
  'product.type_4.0': 'PAMA परीक्षा एक्सेस',
  'product.type_5.0': 'UAMAP परीक्षा एक्सेस',
  'product.type_6.0': 'ऑनलाइन प्रतियोगिता एक्सेस',
  'product.type_7.0': 'ऑफलाइन प्रतियोगिता एक्सेस',
  'product.type_8.0': 'साथी टिकट',
  'product.type_9.0': 'PAMA प्रतियोगिता एक्सेस',
  'product.type_10.0': 'PAMA Global ऑफलाइन प्रतियोगिता एक्सेस',
  'product.type_11.0': 'साथी टिकट',
  // Exams
  ONLY_MENTAL: 'केवल मानसिक',
  // Teacher Level Exams
  ABACUS_ARITHMETIC_ADD_TEACHER_LEVEL_1_SECTION_1: '10 नमूने: 3-4D10R अबाकस',
  ABACUS_ARITHMETIC_ADD_TEACHER_LEVEL_1_SECTION_2: '20 नमूने: 3D3D',
  ABACUS_ARITHMETIC_ADD_TEACHER_LEVEL_1_SECTION_3: '20 नमूने: 4-5D/2-3D',
  ABACUS_ARITHMETIC_ADD_TEACHER_LEVEL_1_SECTION_4: '10 नमूने: 2D6R',
  ABACUS_ARITHMETIC_ADD_TEACHER_LEVEL_1_SECTION_5: '20 नमूने: 2D1D, 3D/1D',
  ABACUS_ARITHMETIC_ADD_TEACHER_LEVEL_2_SECTION_1: '10 नमूने: 2-3D10R अबाकस',
  ABACUS_ARITHMETIC_ADD_TEACHER_LEVEL_2_SECTION_2: '20 नमूने: 2D*2D',
  ABACUS_ARITHMETIC_ADD_TEACHER_LEVEL_2_SECTION_3: '20 नमूने: 3-4D/1D',
  ABACUS_ARITHMETIC_ADD_TEACHER_LEVEL_2_SECTION_4: '10 नमूने: 1D7R',
  ABACUS_ARITHMETIC_ADD_TEACHER_LEVEL_2_SECTION_5: '10 नमूने: 1-2D5R',
  ABACUS_ARITHMETIC_ADD_TEACHER_LEVEL_3_SECTION_1: '50 नमूने: गुणन तालिका',
  ABACUS_ARITHMETIC_ADD_TEACHER_LEVEL_3_SECTION_2: '50 नमूने: भाग तालिका',
  ABACUS_ARITHMETIC_ADD_TEACHER_LEVEL_3_SECTION_3: '20 नमूने: 1-2D10R अबाकस',
  ABACUS_ARITHMETIC_ADD_TEACHER_LEVEL_3_SECTION_4: '20 नमूने: 1D6R',
  // Student Level Exams (6-13)
  ABACUS_ARITHMETIC_ADD_LEVEL_6_SECTION_1: '10 नमूने: 3-4D10R अबाकस',
  ABACUS_ARITHMETIC_MULTIPLICATION_LEVEL_6_SECTION_2: '20 नमूने: 3D2D',
  ABACUS_ARITHMETIC_DIVISION_LEVEL_6_SECTION_3: '20 नमूने: 3-4D/2-3D',
  ABACUS_ARITHMETIC_ADD_LEVEL_6_SECTION_4: '10 नमूने: 2D4R',
  ABACUS_ARITHMETIC_MULTIPLICATION_LEVEL_6_SECTION_5: '20 नमूने: 2-3D1D',
  ABACUS_ARITHMETIC_ADD_LEVEL_7_SECTION_1: '10 नमूने: 2-3D10R अबाकस',
  ABACUS_ARITHMETIC_MULTIPLICATION_LEVEL_7_SECTION_2: '20 नमूने: 2D*2D',
  ABACUS_ARITHMETIC_DIVISION_LEVEL_7_SECTION_3: '20 नमूने: 3-4D/1D',
  ABACUS_ARITHMETIC_ADD_LEVEL_7_SECTION_4: '10 नमूने: 1D7R',
  ABACUS_ARITHMETIC_ADD_LEVEL_7_SECTION_5: '10 नमूने: 1-2D5R',
  ABACUS_ARITHMETIC_ADD_LEVEL_8_SECTION_1: '10 नमूने: 2D10R अबाकस',
  ABACUS_ARITHMETIC_MULTIPLICATION_LEVEL_8_SECTION_2: '20 नमूने: 3D*1D',
  ABACUS_ARITHMETIC_DIVISION_LEVEL_8_SECTION_3: '20 नमूने: 2-3D/1D',
  ABACUS_ARITHMETIC_ADD_LEVEL_8_SECTION_4: '10 नमूने: 1D6R',
  ABACUS_ARITHMETIC_ADD_LEVEL_8_SECTION_5: '10 नमूने: 1-2D4R',
  ABACUS_ARITHMETIC_ADD_LEVEL_9_SECTION_1: '20 नमूने: गुणन तालिका',
  ABACUS_ARITHMETIC_ADD_LEVEL_9_SECTION_2: '10 नमूने: 1-2D10R अबाकस',
  ABACUS_ARITHMETIC_ADD_LEVEL_9_SECTION_3: '10 नमूने: 2D4R अबाकस',
  ABACUS_ARITHMETIC_ADD_LEVEL_9_SECTION_4: '10 नमूने: 1D4R',
  ABACUS_ARITHMETIC_ADD_LEVEL_9_SECTION_5: '10 नमूने: 1D5R',
  ABACUS_ARITHMETIC_ADD_LEVEL_10_SECTION_1: '20 नमूने: 10 के संख्या बंध',
  ABACUS_ARITHMETIC_ADD_LEVEL_10_SECTION_2: '10 नमूने: 1D10R अबाकस',
  ABACUS_ARITHMETIC_ADD_LEVEL_10_SECTION_3: '10 नमूने: 2D4RF5 अबाकस',
  ABACUS_ARITHMETIC_ADD_LEVEL_10_SECTION_4: '10 नमूने: 1D5RF5',
  ABACUS_ARITHMETIC_ADD_LEVEL_10_SECTION_5: '10 नमूने: 1D4RF10',
  ABACUS_ARITHMETIC_ADD_LEVEL_11_SECTION_1: '20 नमूने: 10 के संख्या बंध',
  ABACUS_ARITHMETIC_ADD_LEVEL_11_SECTION_2: '10 नमूने: 1D8RF10 अबाकस',
  ABACUS_ARITHMETIC_ADD_LEVEL_11_SECTION_3: '10 नमूने: 2D3RF5 अबाकस',
  ABACUS_ARITHMETIC_ADD_LEVEL_11_SECTION_4: '10 नमूने: 1D5RNF',
  ABACUS_ARITHMETIC_ADD_LEVEL_11_SECTION_5: '10 नमूने: 1D3RF5',
  ABACUS_ARITHMETIC_ADD_LEVEL_12_SECTION_1: '20 नमूने: 10 के संख्या बंध',
  ABACUS_ARITHMETIC_ADD_LEVEL_12_SECTION_2: '10 नमूने: 1D6RF5 अबाकस',
  ABACUS_ARITHMETIC_ADD_LEVEL_12_SECTION_3: '10 नमूने: 2D3RNF अबाकस',
  ABACUS_ARITHMETIC_ADD_LEVEL_12_SECTION_4: '10 नमूने: 1D4RNF',
  ABACUS_ARITHMETIC_ADD_LEVEL_12_SECTION_5: '20 नमूने: 2D फ्लैश कार्ड',
  ABACUS_ARITHMETIC_ADD_LEVEL_13_SECTION_1: '20 नमूने: 5 के संख्या बंध',
  ABACUS_ARITHMETIC_ADD_LEVEL_13_SECTION_2: '10 नमूने: 1D5RNF अबाकस',
  ABACUS_ARITHMETIC_ADD_LEVEL_13_SECTION_3: '10 दर्पण नमूने: 2D3RNF अबाकस',
  ABACUS_ARITHMETIC_ADD_LEVEL_13_SECTION_4: '10 नमूने: 1D3RNF',
  ABACUS_ARITHMETIC_ADD_LEVEL_13_SECTION_5: '20 नमूने: 1D फ्लैश कार्ड',
  // UI/Management
  VISIBILITY: 'दृश्यता',
  HISTORY_TITLE: 'लेनदेन इतिहास',
  OLIMP_PURCHASES: 'प्रतियोगिता खरीदारियाँ',
  CREATOR: 'निर्माता',
  // News
  files: 'फ़ाइलें',
  fullscreen: 'फ़ुलस्क्रीन',
  DROP_FILES: 'अपलोड करने के लिए फ़ाइलें क्लिक करें, खींचें या पेस्ट करें...',
  NEWS_TYPE: 'समाचार श्रेणी',
  DEFAULT_NEWS: 'सामान्य',
  UPDATE_NEWS: 'अपडेट',
  FEATHERS_NEWS: 'पंख',
  WHITE_NEWS: 'सफेद',
  BLUE_NEWS: 'नीला',
  RED_NEWS: 'लाल',
  YELLOW_NEWS: 'पीला',
  GREEN_NEWS: 'हरा',
  PURPLE_NEWS: 'बैंगनी',
  NEWS_UNCHECKED: 'क्या नया है?',
  NEWS_CHECKED: 'पहले से देखा हुआ',
  NEWS_CHECKED_ALL: 'आप पूरी तरह अपडेट हैं! जारी रखें!',
  NEWS_HEADER: 'ताज़ा खबर!',
  NEWS_EMPTY: 'अभी तक कोई खबर नहीं। जुड़े रहें!',
  FIRST_PAYMENT: 'पहला भुगतान',
  INVITED_STUDENTS_2: 'रेफर किए गए छात्र',
  INVITED_TEACHERS_2: 'रेफर किए गए शिक्षक',
  // Groups/Auth
  GROUP_MEMBERS: 'समूह सदस्य',
  RESTORE_PASSWORD: 'पासवर्ड रीसेट करें',
  DUPLICATES_TITLE: 'क्या यह आपका खाता है?',
  DIRECTORY_DUPLICATES_TITLE: 'संभावित डुप्लीकेट',
  REGISTER_NEW: 'नया पंजीकरण करें',
  /// /////////////////////////////
  DELETE_CONFIRM: 'हटाने की पुष्टि करें',
  // Added later
  // start Nav
  'nav.burger': 'मेनू',
  'nav.ru': 'रूसी',
  'nav.en': 'अंग्रेज़ी',
  'nav.signin': 'लॉगिन',
  'nav.signup': 'साइन अप',
  'nav.forgot_password': 'पासवर्ड भूल गए?',
  'nav.create': 'खाता बनाएं',
  'nav.im_teacher': 'मैं शिक्षक हूँ',
  'nav.im_student': 'मैं छात्र हूँ',
  'nav.register_modal_title': 'आप किस रूप में पंजीकरण कर रहे हैं?',
  // end Nav
  // start Sidebar
  'sidebar.settings': 'सेटिंग्स',
  'sidebar.change_password': 'पासवर्ड बदलें',
  'sidebar.logout': 'लॉग आउट',
  'sidebar.homeworks.await': 'लंबित असाइनमेंट',
  'sidebar.homeworks.check': 'समीक्षा के लिए',
  'sidebar.homeworks.history': 'असाइनमेंट इतिहास',
  // end Sidebar
  // end table
  // register forms
  REGISTER_AS: 'आप प्लेटफ़ॉर्म पर कैसे पंजीकरण करना चाहेंगे?',
  REGISTER_AS_PARENT: 'छात्र के अभिभावक के रूप में',
  REGISTER_AS_TEACHER: 'शिक्षक के रूप में',

  // ACHIEVEMENTS
  // student
  'achievement.student.first_homework.title': 'अच्छी शुरुआत!',
  'achievement.student.first_homework.desc':
    'तुमने अपना पहला गृहकार्य पूरा किया — जारी रखो!',
  'achievement.student.2_homeworks_per_day.title': 'दोगुना मज़ा!',
  'achievement.student.2_homeworks_per_day.desc':
    'आज यह तुम्हारा दूसरा गृहकार्य है — तुम्हें कोई नहीं रोक सकता!',
  'achievement.student.homeworks_for_week_comleted.title': 'बहुत सहज!',
  'achievement.student.homeworks_for_week_comleted.desc':
    'शाबाश! तुम पूरे हफ्ते से अपना सारा गृहकार्य कर रहे हो!',
  'achievement.student.homeworks_for_month_comleted.title': 'मिशन पूरा हुआ',
  'achievement.student.homeworks_for_month_comleted.desc':
    'हम तुम्हारे समर्पण से प्रभावित हैं! तुमने पूरे महीने अपना सारा गृहकार्य किया!',
  'achievement.student.10_homeworks_completed.title': 'छोटा लेकिन शक्तिशाली!',
  'achievement.student.10_homeworks_completed.desc':
    'शानदार! तुमने प्लेटफ़ॉर्म पर 10 गृहकार्य पूरे कर लिए हैं।',
  'achievement.student.50_homeworks_completed.title': 'परिणाम दिख रहा है!',
  'achievement.student.50_homeworks_completed.desc':
    'शानदार! तुमने प्लेटफ़ॉर्म पर 50 गृहकार्य पूरे कर लिए हैं।',
  'achievement.student.100_homeworks_completed.title':
    'मुझे कुछ नहीं रोक सकता!',
  'achievement.student.100_homeworks_completed.desc':
    'शानदार! तुमने प्लेटफ़ॉर्म पर 100 गृहकार्य पूरे कर लिए हैं।',
  'achievement.student.500_homeworks_completed.title': 'अनंत भी कम है!',
  'achievement.student.500_homeworks_completed.desc':
    'अविश्वसनीय! तुमने प्लेटफ़ॉर्म पर 500 गृहकार्य पूरे कर लिए हैं।',
  'achievement.student.set_avatar.title': 'मुस्कुराइए!',
  'achievement.student.set_avatar.desc':
    'प्रोफ़ाइल अवतार सेट करने या बदलने का पुरस्कार',
  'achievement.student.first_olimpic.title': 'बस कोशिश करके देखो!',
  'achievement.student.first_olimpic.desc':
    'अपनी पहली प्रतियोगिता में भाग लेने के लिए बधाई!',
  'achievement.student.olimpic_prize_place.title': 'पुरस्कार मुझे दो!',
  'achievement.student.olimpic_prize_place.desc':
    'प्रतियोगिता में पुरस्कार स्थान जीतने के लिए बधाई!',
  'achievement.student.olimpic_first_place.title': 'सबसे बेहतरीन!',
  'achievement.student.olimpic_first_place.desc':
    'प्रतियोगिता में प्रथम स्थान जीतने के लिए बधाई!',
  'achievement.student.first_exam_access.title': 'मैं तैयार हूँ!',
  'achievement.student.first_exam_access.desc':
    'तुमने अपना पहला परीक्षा दिया — शाबाश!',
  'achievement.student.access_3_month.title': 'साथ मिलकर आगे बढ़ते हैं!',
  'achievement.student.access_3_month.desc':
    'हुर्रे! तुम लगातार 3 महीने से हमारे साथ सीख रहे हो।',
  'achievement.student.access_6_month.title': 'छह महीने एक दिन जैसे',
  'achievement.student.access_6_month.desc':
    'हुर्रे! तुम लगातार 6 महीने से हमारे साथ सीख रहे हो।',
  'achievement.student.access_12_month.title': 'मैं पीछे नहीं हटूँगा...',
  'achievement.student.access_12_month.desc':
    'हुर्रे! तुम पूरे एक साल से हमारे साथ सीख रहे हो।',
  'achievement.student.student_try_uamap.title': 'मैं सिर्फ देखना नहीं चाहता!',
  'achievement.student.student_try_uamap.desc':
    'UAMAP परीक्षा सिमुलेशन की पहली कोशिश का पुरस्कार',
  'achievement.student.student_try_sama_mental.title': 'मेंटल यात्रा शुरू...',
  'achievement.student.student_try_sama_mental.desc':
    'PAMA GLOBAL मेंटल परीक्षा सिमुलेशन की पहली कोशिश का पुरस्कार',
  'achievement.student.student_try_sama_abacus.title':
    'सब कुछ अबाकस से शुरू हुआ...',
  'achievement.student.student_try_sama_abacus.desc':
    'PAMA GLOBAL अबाकस परीक्षा सिमुलेशन की पहली कोशिश का पुरस्कार',
  'achievement.student.uamap_13.title': 'UAMAP पदक स्तर 13',
  'achievement.student.uamap_13.desc':
    'बधाई! तुमने UAMAP स्तर 13 परीक्षा पास की!',
  'achievement.student.uamap_12.title': 'UAMAP पदक स्तर 12',
  'achievement.student.uamap_12.desc':
    'बधाई! तुमने UAMAP स्तर 12 परीक्षा पास की!',
  'achievement.student.uamap_11.title': 'UAMAP पदक स्तर 11',
  'achievement.student.uamap_11.desc':
    'बधाई! तुमने UAMAP स्तर 11 परीक्षा पास की!',
  'achievement.student.uamap_10.title': 'UAMAP पदक स्तर 10',
  'achievement.student.uamap_10.desc':
    'बधाई! तुमने UAMAP स्तर 10 परीक्षा पास की!',
  'achievement.student.uamap_9.title': 'UAMAP पदक स्तर 9',
  'achievement.student.uamap_9.desc':
    'बधाई! तुमने UAMAP स्तर 9 परीक्षा पास की!',
  'achievement.student.uamap_8.title': 'UAMAP पदक स्तर 8',
  'achievement.student.uamap_8.desc':
    'बधाई! तुमने UAMAP स्तर 8 परीक्षा पास की!',
  'achievement.student.uamap_7.title': 'UAMAP पदक स्तर 7',
  'achievement.student.uamap_7.desc':
    'बधाई! तुमने UAMAP स्तर 7 परीक्षा पास की!',
  'achievement.student.uamap_6.title': 'UAMAP पदक स्तर 6',
  'achievement.student.uamap_6.desc':
    'बधाई! तुमने UAMAP स्तर 6 परीक्षा पास की!',
  'achievement.student.sama_abacus_12.title': 'PAMA GLOBAL अबाकस ऑर्डर स्तर 12',
  'achievement.student.sama_abacus_12.desc':
    'बधाई! तुमने PAMA GLOBAL अबाकस स्तर 12 परीक्षा पास की!',
  'achievement.student.sama_abacus_11.title': 'PAMA GLOBAL अबाकस ऑर्डर स्तर 11',
  'achievement.student.sama_abacus_11.desc':
    'बधाई! तुमने PAMA GLOBAL अबाकस स्तर 11 परीक्षा पास की!',
  'achievement.student.sama_abacus_10.title': 'PAMA GLOBAL अबाकस ऑर्डर स्तर 10',
  'achievement.student.sama_abacus_10.desc':
    'बधाई! तुमने PAMA GLOBAL अबाकस स्तर 10 परीक्षा पास की!',
  'achievement.student.sama_abacus_9.title': 'PAMA GLOBAL अबाकस ऑर्डर स्तर 9',
  'achievement.student.sama_abacus_9.desc':
    'बधाई! तुमने PAMA GLOBAL अबाकस स्तर 9 परीक्षा पास की!',
  'achievement.student.sama_abacus_8.title': 'PAMA GLOBAL अबाकस ऑर्डर स्तर 8',
  'achievement.student.sama_abacus_8.desc':
    'बधाई! तुमने PAMA GLOBAL अबाकस स्तर 8 परीक्षा पास की!',
  'achievement.student.sama_abacus_7.title': 'PAMA GLOBAL अबाकस ऑर्डर स्तर 7',
  'achievement.student.sama_abacus_7.desc':
    'बधाई! तुमने PAMA GLOBAL अबाकस स्तर 7 परीक्षा पास की!',
  'achievement.student.sama_abacus_6.title': 'PAMA GLOBAL अबाकस ऑर्डर स्तर 6',
  'achievement.student.sama_abacus_6.desc':
    'बधाई! तुमने PAMA GLOBAL अबाकस स्तर 6 परीक्षा पास की!',
  'achievement.student.sama_abacus_5.title': 'PAMA GLOBAL अबाकस ऑर्डर स्तर 5',
  'achievement.student.sama_abacus_5.desc':
    'बधाई! तुमने PAMA GLOBAL अबाकस स्तर 5 परीक्षा पास की!',
  'achievement.student.sama_abacus_4.title': 'PAMA GLOBAL अबाकस ऑर्डर स्तर 4',
  'achievement.student.sama_abacus_4.desc':
    'बधाई! तुमने PAMA GLOBAL अबाकस स्तर 4 परीक्षा पास की!',
  'achievement.student.sama_abacus_3.title': 'PAMA GLOBAL अबाकस ऑर्डर स्तर 3',
  'achievement.student.sama_abacus_3.desc':
    'बधाई! तुमने PAMA GLOBAL अबाकस स्तर 3 परीक्षा पास की!',
  'achievement.student.sama_abacus_2.title': 'PAMA GLOBAL अबाकस ऑर्डर स्तर 2',
  'achievement.student.sama_abacus_2.desc':
    'बधाई! तुमने PAMA GLOBAL अबाकस स्तर 2 परीक्षा पास की!',
  'achievement.student.sama_abacus_1.title': 'PAMA GLOBAL अबाकस ऑर्डर स्तर 1',
  'achievement.student.sama_abacus_1.desc':
    'बधाई! तुमने PAMA GLOBAL अबाकस स्तर 1 परीक्षा पास की!',
  'achievement.student.sama_mental_12.title':
    'PAMA GLOBAL मेंटल क्राउन स्तर 12',
  'achievement.student.sama_mental_12.desc':
    'बधाई! तुमने PAMA GLOBAL मेंटल स्तर 12 परीक्षा पास की!',
  'achievement.student.sama_mental_11.title':
    'PAMA GLOBAL मेंटल क्राउन स्तर 11',
  'achievement.student.sama_mental_11.desc':
    'बधाई! तुमने PAMA GLOBAL मेंटल स्तर 11 परीक्षा पास की!',
  'achievement.student.sama_mental_10.title':
    'PAMA GLOBAL मेंटल क्राउन स्तर 10',
  'achievement.student.sama_mental_10.desc':
    'बधाई! तुमने PAMA GLOBAL मेंटल स्तर 10 परीक्षा पास की!',
  'achievement.student.sama_mental_9.title': 'PAMA GLOBAL मेंटल क्राउन स्तर 9',
  'achievement.student.sama_mental_9.desc':
    'बधाई! तुमने PAMA GLOBAL मेंटल स्तर 9 परीक्षा पास की!',
  'achievement.student.sama_mental_8.title': 'PAMA GLOBAL मेंटल क्राउन स्तर 8',
  'achievement.student.sama_mental_8.desc':
    'बधाई! तुमने PAMA GLOBAL मेंटल स्तर 8 परीक्षा पास की!',
  'achievement.student.sama_mental_7.title': 'PAMA GLOBAL मेंटल क्राउन स्तर 7',
  'achievement.student.sama_mental_7.desc':
    'बधाई! तुमने PAMA GLOBAL मेंटल स्तर 7 परीक्षा पास की!',
  'achievement.student.sama_mental_6.title': 'PAMA GLOBAL मेंटल क्राउन स्तर 6',
  'achievement.student.sama_mental_6.desc':
    'बधाई! तुमने PAMA GLOBAL मेंटल स्तर 6 परीक्षा पास की!',
  'achievement.student.sama_mental_5.title': 'PAMA GLOBAL मेंटल क्राउन स्तर 5',
  'achievement.student.sama_mental_5.desc':
    'बधाई! तुमने PAMA GLOBAL मेंटल स्तर 5 परीक्षा पास की!',
  'achievement.student.sama_mental_4.title': 'PAMA GLOBAL मेंटल क्राउन स्तर 4',
  'achievement.student.sama_mental_4.desc':
    'बधाई! तुमने PAMA GLOBAL मेंटल स्तर 4 परीक्षा पास की!',
  'achievement.student.sama_mental_3.title': 'PAMA GLOBAL मेंटल क्राउन स्तर 3',
  'achievement.student.sama_mental_3.desc':
    'बधाई! तुमने PAMA GLOBAL मेंटल स्तर 3 परीक्षा पास की!',
  'achievement.student.sama_mental_2.title': 'PAMA GLOBAL मेंटल क्राउन स्तर 2',
  'achievement.student.sama_mental_2.desc':
    'बधाई! तुमने PAMA GLOBAL मेंटल स्तर 2 परीक्षा पास की!',
  'achievement.student.sama_mental_1.title': 'PAMA GLOBAL मेंटल क्राउन स्तर 1',
  'achievement.student.sama_mental_1.desc':
    'बधाई! तुमने PAMA GLOBAL मेंटल स्तर 1 परीक्षा पास की!',
  // teacher
  'achievement.teacher.first_student_exam_completed.title': 'पहला तैयार!',
  'achievement.teacher.first_student_exam_completed.desc':
    '1 छात्र ने कोई भी परीक्षा पास की',
  'achievement.teacher.10_student_exams_completed.title': 'टीम निर्माता!',
  'achievement.teacher.10_student_exams_completed.desc':
    '10 छात्रों ने कोई भी परीक्षा पास की',
  'achievement.teacher.50_student_exams_completed.title': 'मार्गदर्शक',
  'achievement.teacher.50_student_exams_completed.desc':
    '50 छात्रों ने कोई भी परीक्षा पास की',
  'achievement.teacher.homeworks_for_week_comleted.title':
    'उदाहरण स्थापित करना',
  'achievement.teacher.homeworks_for_week_comleted.desc':
    'बधाई! आपके छात्र ने पूरे हफ्ते का सारा गृहकार्य किया!',
  'achievement.teacher.olimpic_prize_1.title': 'ज्ञान बाँटना',
  'achievement.teacher.olimpic_prize_1.desc':
    'बधाई! आपके एक छात्र ने प्रतियोगिता में पुरस्कार जीता!',
  'achievement.teacher.olimpic_prize_3.title': 'सेंसे',
  'achievement.teacher.olimpic_prize_3.desc':
    'बधाई! आपके 3 छात्रों ने प्रतियोगिता में पुरस्कार जीते!',
  'achievement.teacher.olimpic_prize_5.title': 'बुद्धिमान शिक्षक',
  'achievement.teacher.olimpic_prize_5.desc':
    'बधाई! आपके 5 छात्रों ने प्रतियोगिता में पुरस्कार जीते!',
  'achievement.teacher.10_homeworks_created.title': 'आराम का समय नहीं!',
  'achievement.teacher.10_homeworks_created.desc':
    'बढ़िया! आपने अपने छात्रों को 10 गृहकार्य दिए हैं।',
  'achievement.teacher.100_homeworks_created.title': 'अपने काम में माहिर!',
  'achievement.teacher.100_homeworks_created.desc':
    'बढ़िया! आपने अपने छात्रों को 100 गृहकार्य दिए हैं।',
  'achievement.teacher.500_homeworks_created.title':
    'जितना ज़्यादा उतना बेहतर!',
  'achievement.teacher.500_homeworks_created.desc':
    'बढ़िया! आपने अपने छात्रों को 500 गृहकार्य दिए हैं।',
  'achievement.teacher.referal_created_student_1.title': '(+1)',
  'achievement.teacher.referal_created_student_1.desc':
    'बधाई! आपने प्लेटफ़ॉर्म पर एक नया छात्र आमंत्रित किया!',
  'achievement.teacher.referal_created_student_5.title':
    'साथ मिलकर हम मजबूत हैं',
  'achievement.teacher.referal_created_student_5.desc':
    'बधाई! आपने प्लेटफ़ॉर्म पर 5 छात्र आमंत्रित किए!',
  'achievement.teacher.referal_created_student_10.title': 'हम एक टीम हैं!',
  'achievement.teacher.referal_created_student_10.desc':
    'बधाई! आपने प्लेटफ़ॉर्म पर 10 छात्र आमंत्रित किए!',
  'achievement.teacher.referal_created_teacher_1.title': 'अब अकेले नहीं!',
  'achievement.teacher.referal_created_teacher_1.desc':
    'बधाई! आपने प्लेटफ़ॉर्म पर एक नया शिक्षक आमंत्रित किया!',
  'achievement.teacher.referal_created_teacher_3.title': 'सब परिवार यहाँ!',
  'achievement.teacher.referal_created_teacher_3.desc':
    'बधाई! आपने प्लेटफ़ॉर्म पर 3 शिक्षक आमंत्रित किए!',
  'achievement.teacher.referal_created_teacher_5.title':
    'मुझे अपनी नौकरी पसंद है!',
  'achievement.teacher.referal_created_teacher_5.desc':
    'बधाई! आपने प्लेटफ़ॉर्म पर 5 शिक्षक आमंत्रित किए!',
  'achievement.teacher.pay_for_student_access.title': 'भविष्य में निवेश',
  'achievement.teacher.pay_for_student_access.desc':
    'आपने अभी-अभी अपने छात्र की प्लेटफ़ॉर्म सदस्यता का भुगतान किया — यह रहा आपका पुरस्कार!',
  'achievement.teacher.pay_for_student_olimpic.title': 'देखभाल दिखाना',
  'achievement.teacher.pay_for_student_olimpic.desc':
    'आपने अभी-अभी अपने छात्र की प्रतियोगिता भागीदारी का भुगतान किया — यह रहा आपका पुरस्कार!',
  'achievement.teacher.topup_account.title': 'काम आएगा!',
  'achievement.teacher.topup_account.desc':
    'आपने अपना खाता रिचार्ज किया — एक छोटा सा उपहार का आनंद लें!',
  'achievement.teacher.set_avatar.title': 'मुस्कुराइए!',
  'achievement.teacher.set_avatar.desc':
    'प्रोफ़ाइल अवतार सेट करने या बदलने का पुरस्कार',
  'achievement.teacher.complete_profile.title': 'हममें से एक!',
  'achievement.teacher.complete_profile.desc':
    'सभी प्रोफ़ाइल फ़ील्ड भरने का पुरस्कार',
  'achievement.teacher.uamap_1.title': 'UAMAP प्रमाणपत्र स्तर 1',
  'achievement.teacher.uamap_1.desc': 'बधाई! आपने UAMAP स्तर 1 परीक्षा पास की',
  'achievement.teacher.uamap_2.title': 'UAMAP प्रमाणपत्र स्तर 2',
  'achievement.teacher.uamap_2.desc': 'बधाई! आपने UAMAP स्तर 2 परीक्षा पास की',
  'achievement.teacher.uamap_3.title': 'UAMAP प्रमाणपत्र स्तर 3',
  'achievement.teacher.uamap_3.desc': 'बधाई! आपने UAMAP स्तर 3 परीक्षा पास की',
  'achievement.teacher.sama_3.title': '3 तारे PAMA GLOBAL',
  'achievement.teacher.sama_3.desc':
    'बधाई! आपने PAMA GLOBAL में 3 तारे अर्जित किए',
  'achievement.teacher.sama_5.title': '2 तारे PAMA GLOBAL',
  'achievement.teacher.sama_5.desc':
    'बधाई! आपने PAMA GLOBAL में 2 तारे अर्जित किए',
  'achievement.teacher.sama_7.title': '1 तारा PAMA GLOBAL',
  'achievement.teacher.sama_7.desc':
    'बधाई! आपने PAMA GLOBAL में 1 तारा अर्जित किया',
  // other
  SOUND_ON: 'चालू',
  DAILY: 'दैनिक',
  COMPLETE_BY: 'तक पूर्ण करें',
  SPECIFIC_DAYS: 'निर्दिष्ट दिन',
  SPECIFIC_DAYS_MULTIPLE: 'निर्दिष्ट दिन (एकाधिक तिथियाँ स्वीकार्य)',
  MONTHS_LIST:
    'जनवरी,फरवरी,मार्च,अप्रैल,मई,जून,जुलाई,अगस्त,सितंबर,अक्टूबर,नवंबर,दिसंबर',
  MONTHS_SHORT: 'जन,फर,मार्च,अप्रै,मई,जून,जुला,अग,सित,अक्टू,नव,दिस',
  WEEKDAYS_LONG: 'रविवार,सोमवार,मंगलवार,बुधवार,गुरुवार,शुक्रवार,शनिवार',
  WEEKDAYS_SHORT: 'रवि,सोम,मंगल,बुध,गुरु,शुक्र,शनि',
  NEXT_MONTH: 'अगला माह',
  PREVIOUS_MONTH: 'पिछला माह',
  GENDER_MALE: 'पुरुष',
  GENDER_FEMALE: 'महिला',
  THEME_STANDARD: 'मानक',
  THEME_STANDARD_DESC: 'सभी उपयोगकर्ताओं के लिए उपलब्ध थीम',
  THEME_UNIQUE: 'अद्वितीय',
  THEME_UNIQUE_DESC: 'जादुई पंखों के लिए उपलब्ध थीम',
  BRAND_THEME: 'ब्रांड थीम',
  ABACUS_COLOR_CHOICE: 'यहाँ आप अपने अबाकस के लिए मनकों का रंग चुन सकते हैं',
  EGYPT_THEME_DESC:
    'पिरामिडों, फिरौन और छिपे खजाने के साथ जादुई प्राचीन मिस्र का अन्वेषण करें!',
  INSTALL: 'उपयोग करें',
  OWL_GREETING: 'नमस्ते, मेरा नाम उल्लू यूनी है',
  CONFIGURE_TRAINER: 'प्रशिक्षक कॉन्फ़िगर करें',
  CHOOSE_TASK_TEXT: 'एक उपयुक्त कार्य चुनें और मुझे अपने परिणामों से चकित करें',
  QUICK_START: 'त्वरित शुरुआत',
  QUICK_START_DESC:
    'यादृच्छिक सेटिंग्स के साथ अभी प्रशिक्षण शुरू करने के लिए क्लिक करें',
  TABLE_SIZE: 'तालिका आकार',
  NUMBER_DIGITS: 'अंकों की संख्या',
  SHUFFLE_ON_CLICK: 'क्लिक पर शफ़ल करें',
  CENTER_DOT: 'केंद्र बिंदु',
  SYMBOL_ORDER: 'प्रतीक क्रम',
  TABLE_TYPE: 'तालिका प्रकार',
  DIRECT_ORDER: 'सीधा',
  REVERSE_ORDER: 'उल्टा',
  RANDOM_ORDER: 'यादृच्छिक',
  NUMBERS: 'संख्याएँ',
  SOUND_VOLUME: 'ध्वनि वॉल्यूम',
  FIND_SYMBOL: 'प्रतीक खोजें',
  // other
  DIGIT_RANGE: 'अंक सीमा',
  FOR_WHOM: 'किसके लिए',
  REDUCE_TABLE: 'तालिका छोटी करें',
  // correct or wrong phrases when user solves samples
  OWL_SUCCESS_1: 'When you solve the problem correctly',
  OWL_SUCCESS_2: 'Simply excellent',
  OWL_SUCCESS_3: 'Ha, easy peasy!',
  OWL_SUCCESS_4: "You're incredibly awesome",
  OWL_SUCCESS_5: 'Answer is correct',
  OWL_SUCCESS_6: 'Excellent work',
  OWL_SUCCESS_7: 'Got a perfect score',
  OWL_SUCCESS_8: "That's just awesome!",
  OWL_SUCCESS_9: 'You did it?!',
  OWL_SUCCESS_10: 'Super smart',
  OWL_SUCCESS_11: "Let's keep going!",
  OWL_SUCCESS_12: 'Nailed it!',
  OWL_SUCCESS_13: 'Easy win',
  OWL_SUCCESS_14: 'YOSH!',
  OWL_SUCCESS_15: 'Incredible!',
  OWL_SUCCESS_16: 'You did it!',
  OWL_SUCCESS_17: 'The sharpest answer in the Wild West',
  OWL_SUCCESS_18: 'Humanity has never been this close to perfection!',

  OWL_FAILED_1: 'Unfortunately, no…',
  OWL_FAILED_2: "Looks like someone's too chill today",
  OWL_FAILED_3: 'Oh my god',
  OWL_FAILED_4: 'Answer is incorrect…',
  OWL_FAILED_5: 'Are you sure you signed up for mental arithmetic?',
  OWL_FAILED_6: 'Wrong approach',
  OWL_FAILED_7: 'Nope!',
  OWL_FAILED_8: 'Another try?',
  OWL_FAILED_9: 'I disapprove',
  OWL_FAILED_10: "Don't be upset...",
  OWL_FAILED_11: 'Try again…',
  OWL_FAILED_12: 'I really believed in you...',
  OWL_FAILED_13: 'Again...',
  OWL_FAILED_14: 'If you struggle long enough, something will work out!',
  OWL_FAILED_15: 'Well, shoot',
  OWL_FAILED_16: 'Years of effort, mountains of trying, all for this',
  OWL_FAILED_17: 'What could have gone wrong this time?',
  OWL_FAILED_18: 'Next time it will work!',
  // other
  FULLSCREEN: 'फ़ुलस्क्रीन',
  EXIT_FULLSCREEN: 'फ़ुलस्क्रीन बंद करें',
  CURRENT_RANK: 'आपकी वर्तमान रैंक:',
  PAST_WINNERS: 'पिछले विजेता',
  WINNER_TABLE_CREATE_TITLE: 'नया विजेता जोड़ें',
  EDIT_WINNER_TITLE: 'विजेता संपादित करें',
  CHOOSE_OLIMPIC_NAME: 'प्रतियोगिता चुनें',
  CONFIRM_DELETE_WINNER: 'क्या आप वाकई विजेता का रिकॉर्ड हटाना चाहते हैं?',
  FILE_SIZE_ERROR: 'कृपया 3MB से बड़ा नहीं फ़ोटो चुनें',
  FILE_TYPE_ERROR:
    'अमान्य फ़ाइल प्रकार। कृपया एक छवि (JPEG, PNG, आदि) अपलोड करें',
  SAVE_WINNERS_RESULT: 'परिणाम सहेजें',
  CONFIRM_SAVE_WINNERS:
    'क्या आप वाकई परिणाम सहेजना चाहते हैं? महत्वपूर्ण! स्थान निर्धारित होने चाहिए।',
  NO_PLACES_WARNING: 'स्थान 0/1 निर्दिष्ट नहीं हैं!',
  IMPORTANT_FIELDS_LOCKED:
    'नाम, उपनाम और जन्म तिथि केवल एक बार बदली जा सकती है। कृपया सहायता के लिए व्यवस्थापक से संपर्क करें।',
  LOGIN_CHANGE_CONFIRM:
    'प्रोफ़ाइल में अपना ईमेल संपादित करने के बाद, आपके खाते के लिए लॉगिन ईमेल बदल गया है।',
  TEMPLATES: 'टेम्पलेट',
  CATEGORY_NAME_VALIDATION:
    'श्रेणी नाम में केवल बड़े लैटिन अक्षर और अंक होने चाहिए',
  DIPLOMS_RECORDS_TEMPLATES: 'डिप्लोमा रिकॉर्ड के लिए टेम्पलेट',
  MAIN_TEMPLATE: 'डिफ़ॉल्ट टेम्पलेट',
  CONFIRM_DELETE_TEMPLATE: 'क्या आप वाकई इस टेम्पलेट को हटाना चाहते हैं?',
  TEMPLATE_CREATE_TITLE: 'टेम्पलेट बनाएं',
  TEMPLATE_EDIT_TITLE: 'टेम्पलेट संपादित करें',
  TEMPLATE_SUCCESS_CREATE_MESSAGE: 'टेम्पलेट सफलतापूर्वक बनाया गया',
  TEMPLATE_SUCCESS_EDIT_MESSAGE: 'टेम्पलेट सफलतापूर्वक अपडेट किया गया',
  ADD_STAGE: 'चरण जोड़ें',
  ADD_CATEGORY: 'श्रेणी जोड़ें',
  VARIANT: 'गिनती प्रकार',
  SHORT_RECORD: 'संक्षिप्त रिकॉर्ड',
  CATEGORY_NAME: 'श्रेणी नाम',
  SAMPLES_TYPE: 'कार्य प्रकार',
  TEMPLATE_FORM_TEXT: 'डिप्लोमा रिकॉर्ड के लिए टेम्पलेट चुनें',
  // Рейтинг звезд
  BEST_STUDENTS: 'सर्वश्रेष्ठ छात्र',
  RESET_STARS: 'तारे रीसेट करें',
  OPEN_ALL: 'सभी देखें',
  LOADING: 'लोड हो रहा है...',
  TAB_IN_SCHOOL: 'विद्यालय',
  TAB_WITH_TEACHER: 'शिक्षक के साथ',
  TAB_IN_GROUP: 'समूह में',
  NO_RATING_DATA: 'रेटिंग में अभी तक कोई छात्र नहीं',
  SCHOOL_STAR_RATING: 'विद्यालय रेटिंग',
  GROUPS_STAR_RATING: 'समूह के अनुसार रेटिंग',
  TEACHER_STAR_RATING: 'शिक्षक के अनुसार रेटिंग',
  CONFIRM_RESET_STARS:
    'क्या आप वाकई अपने सभी छात्रों के तारे रीसेट करना चाहते हैं?',
  CONFIRM_RESET_SCHOOL_STARS:
    'क्या आप वाकई इन छात्रों के तारे रीसेट करना चाहते हैं?',
  RATING_SCHOOL_MESSAGE:
    'तारे रीसेट करने के लिए छात्रों (अपने और शिक्षकों के) का चयन करें',
  NO_TEACHERS: 'कोई शिक्षक नहीं मिला',
  STAR_RATING_CLUE:
    'आपके छात्रों के गृहकार्य के लिए तारे। आप अपनी इच्छानुसार छात्रों को पुरस्कृत कर सकते हैं, जिससे बच्चों की प्रेरणा बढ़ती है। पुरस्कार, परिणामों की तिथियाँ और स्थानों की संख्या आपकी इच्छानुसार हैं।',
  SETTING_ON: 'चालू',
  SMGL_USERS_TITLE: 'PAMA उपयोगकर्ता',
  OPERATION_COMPLETED: 'संचालन सफलतापूर्वक पूर्ण हुआ',
  DELETED_COUNT: 'हटाए गए उपयोगकर्ता: {count}',
  SHOW_RATING_FOR_UAMAP: 'Uamap पर रेटिंग दिखाएं',
  PAMA_GLOBAL_RATING: 'PAMA Global रेटिंग',
  SHOW_IN_ROW: 'पंक्ति में दिखाएं',
  PAMA_GLOBAL_PRINT: 'PAMA Global कार्य प्रिंट करें',
  PAMA_OFFLINE_OLIMPIC: 'PAMA Global ऑफलाइन',
  PAMA_OFFLINE_FOR_STUDENT: 'छात्र के लिए PAMA Global ऑफलाइन',
  PAMA_OFFLINE_FOR_TEACHER: 'शिक्षक के लिए PAMA Global ऑफलाइन',
  MAINTAINER_PAMA: 'PAMA Global साथी',
  PAMA_OFFLINE_PARTICIPANTS: 'PAMA Global ऑफलाइन प्रतिभागी',
  PAMA_OFFLINE_OLIMPIC_PAYMENT: 'PAMA GLOBAL ऑफलाइन प्रतियोगिता भागीदारी खरीद',
  MAINTAINER_PAMA_PAYMENT: 'PAMA GLOBAL ऑफलाइन प्रतियोगिता का साथी',
  PAMA_OFFLINE_OLIMPIC_PAY_PARTICIPATE:
    'PAMA Global ऑफलाइन प्रतियोगिता भागीदारी के लिए भुगतान करें',
  // ..
  PRACTICE_ON_TAB: 'टैब पर अभ्यास करें',
  WITH_ACTIVE_ACCESS: 'हमारे प्लेटफ़ॉर्म पर सक्रिय एक्सेस के साथ',
  ACCOMPANY_PARTICIPANT_TEXT:
    'यदि आप प्रतिभागी के साथ जाने की योजना बना रहे हैं, तो कृपया उनके लिए भी टिकट खरीदें।',
  CURRENT_COMPANION_LIMIT: 'वर्तमान साथी सीमा:',
  COMPANION_SALES_CLOSED: 'साथी टिकट बिक्री बंद है।',
  PURCHASED_TEXT: 'खरीदा गया:',
  COMPANION_TICKET_ONE: 'टिकट',
  COMPANION_TICKET_TWO: 'टिकट',
  COMPANION_TICKET_FIVE: 'टिकट',
  OF_COMPANIONS: 'साथियों के लिए',
  TICKET_DATA_WARNING:
    'टिकट बनाने के लिए निम्नलिखित डेटा का उपयोग किया जाएगा, कृपया सटीकता जांचें',
  TICKET_EMAIL_DELIVERY_PAMA:
    'निर्दिष्ट ईमेल पते पर निर्धारित समय सीमा के भीतर टिकट भेजा जाएगा।',
  TICKET_EMAIL_DELIVERY_OLIMPIC:
    'टिकट 3-5 कार्यदिवसों के भीतर निर्दिष्ट ईमेल पते पर भेजा जाएगा। यदि ऐसा नहीं हुआ है, तो कृपया हमसे संपर्क करें',
  TELEGRAM_LINK_TEXT: 'टेलीग्राम',
  EDIT_PROFILE_IF_ERROR: 'त्रुटि होने पर, कृपया अपना प्रोफ़ाइल संपादित करें',
  PHOTO_UPLOAD_NOTICE:
    'किसी भी क्लाउड स्टोरेज पर फ़ोटो (अधिकतम 10 MB) अपलोड करें। लिंक कॉपी करें और यहाँ पेस्ट करें। सुनिश्चित करें कि लिंक की पहुँच खुली है।',
  SELECT_CATEGORY_PLACEHOLDER: 'श्रेणी चुनें',
  SELECT_COUNTRY_PLACEHOLDER: 'देश चुनें',
  RULES_AGREEMENT:
    'मैंने प्रतियोगिता नियमों को पढ़ लिया है और उनमें वर्णित सभी नियमों को स्वीकार करता हूँ।',
  CATEGORY_WARNING:
    'यदि आपने पहले पुरस्कार जीता है तो श्रेणी को सख्ती से ऊपर चुनें। नियमों का पालन न करने पर अयोग्यता हो सकती है।',
  MAINTAINERS_LIMIT_REACHED: 'साथियों की अधिकतम संख्या तक पहुँच गई।',
  STUDENT_TABLE_REGISTER_NOTICE:
    'कृपया उपयोगकर्ता को उनके व्यक्तिगत खाते में प्रतियोगिता के लिए पंजीकृत करें',
  COMPANION_REGISTRATION_REQUIRED:
    'खरीदने के लिए प्रतियोगिता के लिए पंजीकरण आवश्यक है',
  MAINTAINERS_ONE_PURCHASE: '1 साथी / खरीद',
  MAINTAINERS_OTHER_PURCHASE: '{count} साथी / खरीद',
  OFFICIAL_MODE: 'आधिकारिक PAMA नमूने सक्रिय करें',
  NUMBERS_TITLE: 'स्मृति संख्याएँ',
  LENGTH_WORD: 'लंबाई',
  DIGITS_SHORT: 'अंक.',
  PROGRESS_WORD: 'प्रगति',
  WRITE_ANSWER_INTERMEDIATE: 'अपना उत्तर लिखें! नई संख्या...',
  WRITE_ANSWER: 'अपना उत्तर लिखें!',
  PAUSE: 'विराम',
  CHECK_ANSWERS: 'अपने उत्तर जांचें।',
  STAGE_FINISHED: 'चरण पूर्ण!',
  NUMBER_WORD: 'संख्या',
  buy_books: 'पाठ्यपुस्तकें खरीदें',
  CHAMPION_OF_CHAMPIONS: 'चैंपियनों का चैंपियन',
  // new
  MAINTAINERS_REGISTRATION_FORM: 'साथी पंजीकरण फ़ॉर्म',
  REGISTER_MAINTAINERS: 'साथी पंजीकृत करें',
  HIDE_MAINTAINERS_FORM: 'साथी फ़ॉर्म छिपाएं',
  MAINTAINERS_SUCCESS_SAVED: 'साथी सफलतापूर्वक पंजीकृत',
  PHOTO_LINK_MAINTAINER: 'साथी फ़ोटो लिंक',
  RELATION: 'भूमिका',
  RELATION_PARENT: 'अभिभावक',
  RELATION_TEACHER: 'शिक्षक',
  MAINTAINERS_FILL_ALL_FIELDS: 'कम से कम एक साथी के लिए सभी आवश्यक फ़ील्ड भरें',
  MAINTAINERS: 'साथी',
  MAINTAINERS_LOADED_COUNT: 'लोड किए गए साथी: {count}',
  UNFILLED_MAINTAINERS: 'अपंजीकृत साथी',
  EDIT_MAINTAINER: 'साथी संपादित करें',
  CONFIRM_DELETE_MAINTAINER:
    'क्या आप वाकई इस साथी को हटाना चाहते हैं? प्रतिभागी का साथी टिकट काउंटर 1 से कम हो जाएगा।',
  FULL_NAME_EN: 'अंग्रेज़ी में पूरा नाम',
  DONT_SHOW_AGAIN: 'फिर से न दिखाएं',
  PRINT_ALL_STAGES: 'सभी चरण एक साथ प्रिंट करें',
};
